var items = {
  "block.minecraft.acacia_button": "Botó d'acàcia",
  "block.minecraft.acacia_door": "Porta d'acàcia",
  "block.minecraft.acacia_fence": "Tanca d'acàcia",
  "block.minecraft.acacia_fence_gate": "Porta de tanca d'acàcia",
  "block.minecraft.acacia_hanging_sign": "Cartell penjant d'acàcia",
  "block.minecraft.acacia_leaves": "Fulles d'acàcia",
  "block.minecraft.acacia_log": "Tronc d'acàcia",
  "block.minecraft.acacia_planks": "Fusta d'acàcia",
  "block.minecraft.acacia_pressure_plate": "Placa de pressió d'acàcia",
  "block.minecraft.acacia_sapling": "Esqueix d'acàcia",
  "block.minecraft.acacia_shelf": "Prestatge d'acàcia",
  "block.minecraft.acacia_sign": "Cartell d'acàcia",
  "block.minecraft.acacia_slab": "Llosa d'acàcia",
  "block.minecraft.acacia_stairs": "Escales d'acàcia",
  "block.minecraft.acacia_trapdoor": "Trapa d'acàcia",
  "block.minecraft.acacia_wall_hanging_sign": "Cartell penjant d'acàcia amb suport",
  "block.minecraft.acacia_wall_sign": "Cartell d'acàcia a la paret",
  "block.minecraft.acacia_wood": "Fusta d'acàcia",
  "block.minecraft.activator_rail": "Rail activador",
  "block.minecraft.air": "Aire",
  "block.minecraft.allium": "All bord",
  "block.minecraft.amethyst_block": "Bloc d'ametista",
  "block.minecraft.amethyst_cluster": "Cúmul d'ametista",
  "block.minecraft.ancient_debris": "Restes ancestrals",
  "block.minecraft.andesite": "Andesita",
  "block.minecraft.andesite_slab": "Llosa d'andesita",
  "block.minecraft.andesite_stairs": "Escales d'andesita",
  "block.minecraft.andesite_wall": "Mur d'andesita",
  "block.minecraft.anvil": "Enclusa",
  "block.minecraft.attached_melon_stem": "Tija de síndria connectada",
  "block.minecraft.attached_pumpkin_stem": "Tija de carbassa connectada",
  "block.minecraft.azalea": "Azalea",
  "block.minecraft.azalea_leaves": "Fulles d'azalea",
  "block.minecraft.azure_bluet": "Houstonia caerulea",
  "block.minecraft.bamboo": "Bambú",
  "block.minecraft.bamboo_block": "Bloc de bambú",
  "block.minecraft.bamboo_button": "Botó de bambú",
  "block.minecraft.bamboo_door": "Porta de bambú",
  "block.minecraft.bamboo_fence": "Tanca de bambú",
  "block.minecraft.bamboo_fence_gate": "Porta de tanca de bambú",
  "block.minecraft.bamboo_hanging_sign": "Cartell penjant de bambú",
  "block.minecraft.bamboo_mosaic": "Bambú entrellaçat",
  "block.minecraft.bamboo_mosaic_slab": "Llosa de bambú entrellaçat",
  "block.minecraft.bamboo_mosaic_stairs": "Escales de bambú entrellaçat",
  "block.minecraft.bamboo_planks": "Fusta de bambú",
  "block.minecraft.bamboo_pressure_plate": "Placa de pressió de bambú",
  "block.minecraft.bamboo_sapling": "Brot de bambú",
  "block.minecraft.bamboo_shelf": "Prestatge de bambú",
  "block.minecraft.bamboo_sign": "Cartell de bambú",
  "block.minecraft.bamboo_slab": "Llosa de bambú",
  "block.minecraft.bamboo_stairs": "Escales de bambú",
  "block.minecraft.bamboo_trapdoor": "Trapa de bambú",
  "block.minecraft.bamboo_wall_hanging_sign": "Cartell penjant de bambú amb suport",
  "block.minecraft.bamboo_wall_sign": "Cartell de bambú a la paret",
  "block.minecraft.banner.base.black": "Camp de sable",
  "block.minecraft.banner.base.blue": "Camp d'atzur",
  "block.minecraft.banner.base.brown": "Camp marró",
  "block.minecraft.banner.base.cyan": "Camp cian",
  "block.minecraft.banner.base.gray": "Camp gris",
  "block.minecraft.banner.base.green": "Camp de sinople",
  "block.minecraft.banner.base.light_blue": "Camp blau cel",
  "block.minecraft.banner.base.light_gray": "Camp d'argent",
  "block.minecraft.banner.base.lime": "Camp llima",
  "block.minecraft.banner.base.magenta": "Camp magenta",
  "block.minecraft.banner.base.orange": "Camp ataronjat",
  "block.minecraft.banner.base.pink": "Camp rosa",
  "block.minecraft.banner.base.purple": "Camp de porpra",
  "block.minecraft.banner.base.red": "Camp de gules",
  "block.minecraft.banner.base.white": "Camp blanc",
  "block.minecraft.banner.base.yellow": "Camp d'or",
  "block.minecraft.banner.border.black": "Bordura de sable",
  "block.minecraft.banner.border.blue": "Bordura d'atzur",
  "block.minecraft.banner.border.brown": "Bordura marró",
  "block.minecraft.banner.border.cyan": "Bordura cian",
  "block.minecraft.banner.border.gray": "Bordura grisa",
  "block.minecraft.banner.border.green": "Bordura de sinople",
  "block.minecraft.banner.border.light_blue": "Bordura blau cel",
  "block.minecraft.banner.border.light_gray": "Bordura d'argent",
  "block.minecraft.banner.border.lime": "Bordura llima",
  "block.minecraft.banner.border.magenta": "Bordura magenta",
  "block.minecraft.banner.border.orange": "Bordura ataronjada",
  "block.minecraft.banner.border.pink": "Bordura rosa",
  "block.minecraft.banner.border.purple": "Bordura de porpra",
  "block.minecraft.banner.border.red": "Bordura de gules",
  "block.minecraft.banner.border.white": "Bordura blanca",
  "block.minecraft.banner.border.yellow": "Bordura d'or",
  "block.minecraft.banner.bricks.black": "Maçonat de sable",
  "block.minecraft.banner.bricks.blue": "Maçonat d'atzur",
  "block.minecraft.banner.bricks.brown": "Maçonat marró",
  "block.minecraft.banner.bricks.cyan": "Maçonat cian",
  "block.minecraft.banner.bricks.gray": "Maçonat gris",
  "block.minecraft.banner.bricks.green": "Maçonat de sinople",
  "block.minecraft.banner.bricks.light_blue": "Maçonat blau cel",
  "block.minecraft.banner.bricks.light_gray": "Maçonat d'argent",
  "block.minecraft.banner.bricks.lime": "Maçonat llima",
  "block.minecraft.banner.bricks.magenta": "Maçonat magenta",
  "block.minecraft.banner.bricks.orange": "Maçonat ataronjat",
  "block.minecraft.banner.bricks.pink": "Maçonat rosa",
  "block.minecraft.banner.bricks.purple": "Maçonat de porpra",
  "block.minecraft.banner.bricks.red": "Maçonat de gules",
  "block.minecraft.banner.bricks.white": "Maçonat blanc",
  "block.minecraft.banner.bricks.yellow": "Maçonat d'or",
  "block.minecraft.banner.circle.black": "Rodella de sable",
  "block.minecraft.banner.circle.blue": "Rodella d'atzur",
  "block.minecraft.banner.circle.brown": "Rodella marró",
  "block.minecraft.banner.circle.cyan": "Rodella cian",
  "block.minecraft.banner.circle.gray": "Rodella grisa",
  "block.minecraft.banner.circle.green": "Rodella de sinople",
  "block.minecraft.banner.circle.light_blue": "Rodella blau cel",
  "block.minecraft.banner.circle.light_gray": "Besant d'argent",
  "block.minecraft.banner.circle.lime": "Rodella llima",
  "block.minecraft.banner.circle.magenta": "Rodella magenta",
  "block.minecraft.banner.circle.orange": "Rodella ataronjada",
  "block.minecraft.banner.circle.pink": "Rodella rosa",
  "block.minecraft.banner.circle.purple": "Rodella de porpra",
  "block.minecraft.banner.circle.red": "Rodella de gules",
  "block.minecraft.banner.circle.white": "Rodella blanca",
  "block.minecraft.banner.circle.yellow": "Besant d'or",
  "block.minecraft.banner.creeper.black": "Cara de creeper de sable",
  "block.minecraft.banner.creeper.blue": "Cara de creeper d'atzur",
  "block.minecraft.banner.creeper.brown": "Cara de creeper marró",
  "block.minecraft.banner.creeper.cyan": "Cara de creeper cian",
  "block.minecraft.banner.creeper.gray": "Cara de creeper gris",
  "block.minecraft.banner.creeper.green": "Cara de creeper de sinople",
  "block.minecraft.banner.creeper.light_blue": "Cara de creeper blau cel",
  "block.minecraft.banner.creeper.light_gray": "Cara de creeper d'argent",
  "block.minecraft.banner.creeper.lime": "Cara de creeper llima",
  "block.minecraft.banner.creeper.magenta": "Cara de creeper magenta",
  "block.minecraft.banner.creeper.orange": "Cara de creeper ataronjada",
  "block.minecraft.banner.creeper.pink": "Cara de creeper rosa",
  "block.minecraft.banner.creeper.purple": "Cara de creeper porpra",
  "block.minecraft.banner.creeper.red": "Cara de creeper de gules",
  "block.minecraft.banner.creeper.white": "Cara de creeper blanca",
  "block.minecraft.banner.creeper.yellow": "Cara de creeper d'or",
  "block.minecraft.banner.cross.black": "Sautor de sable",
  "block.minecraft.banner.cross.blue": "Sautor d'atzur",
  "block.minecraft.banner.cross.brown": "Sautor marró",
  "block.minecraft.banner.cross.cyan": "Sautor cian",
  "block.minecraft.banner.cross.gray": "Sautor gris",
  "block.minecraft.banner.cross.green": "Sautor de sinople",
  "block.minecraft.banner.cross.light_blue": "Sautor blau cel",
  "block.minecraft.banner.cross.light_gray": "Sautor d'argent",
  "block.minecraft.banner.cross.lime": "Sautor llima",
  "block.minecraft.banner.cross.magenta": "Sautor magenta",
  "block.minecraft.banner.cross.orange": "Sautor ataronjat",
  "block.minecraft.banner.cross.pink": "Sautor rosa",
  "block.minecraft.banner.cross.purple": "Sautor de porpra",
  "block.minecraft.banner.cross.red": "Sautor de gules",
  "block.minecraft.banner.cross.white": "Sautor blanc",
  "block.minecraft.banner.cross.yellow": "Sautor d'or",
  "block.minecraft.banner.curly_border.black": "Bordura dentada de sable",
  "block.minecraft.banner.curly_border.blue": "Bordura dentada d'atzur",
  "block.minecraft.banner.curly_border.brown": "Bordura dentada marró",
  "block.minecraft.banner.curly_border.cyan": "Bordura dentada cian",
  "block.minecraft.banner.curly_border.gray": "Bordura dentada grisa",
  "block.minecraft.banner.curly_border.green": "Bordura dentada de sinople",
  "block.minecraft.banner.curly_border.light_blue": "Bordura dentada blau cel",
  "block.minecraft.banner.curly_border.light_gray": "Bordura dentada d'argent",
  "block.minecraft.banner.curly_border.lime": "Bordura dentada llima",
  "block.minecraft.banner.curly_border.magenta": "Bordura dentada magenta",
  "block.minecraft.banner.curly_border.orange": "Bordura dentada ataronjada",
  "block.minecraft.banner.curly_border.pink": "Bordura dentada rosa",
  "block.minecraft.banner.curly_border.purple": "Bordura dentada de porpra",
  "block.minecraft.banner.curly_border.red": "Bordura dentada de gules",
  "block.minecraft.banner.curly_border.white": "Bordura dentada blanca",
  "block.minecraft.banner.curly_border.yellow": "Bordura dentada d'or",
  "block.minecraft.banner.diagonal_left.black": "Tallat, 1r de sable",
  "block.minecraft.banner.diagonal_left.blue": "Tallat, 1r d'atzur",
  "block.minecraft.banner.diagonal_left.brown": "Tallat, 1r marró",
  "block.minecraft.banner.diagonal_left.cyan": "Tallat, 1r cian",
  "block.minecraft.banner.diagonal_left.gray": "Tallat, 1r gris",
  "block.minecraft.banner.diagonal_left.green": "Tallat, 1r de sinople",
  "block.minecraft.banner.diagonal_left.light_blue": "Tallat, 1r blau cel",
  "block.minecraft.banner.diagonal_left.light_gray": "Tallat, 1r d'argent",
  "block.minecraft.banner.diagonal_left.lime": "Tallat, 1r llima",
  "block.minecraft.banner.diagonal_left.magenta": "Tallat, 1r magenta",
  "block.minecraft.banner.diagonal_left.orange": "Tallat, 1r ataronjat",
  "block.minecraft.banner.diagonal_left.pink": "Tallat, 1r rosa",
  "block.minecraft.banner.diagonal_left.purple": "Tallat, 1r de porpra",
  "block.minecraft.banner.diagonal_left.red": "Tallat, 1r de gules",
  "block.minecraft.banner.diagonal_left.white": "Tallat, 1r blanc",
  "block.minecraft.banner.diagonal_left.yellow": "Tallat, 1r d'or",
  "block.minecraft.banner.diagonal_right.black": "Trinxat, 1r de sable",
  "block.minecraft.banner.diagonal_right.blue": "Trinxat, 1r d'atzur",
  "block.minecraft.banner.diagonal_right.brown": "Trinxat, 1r marró",
  "block.minecraft.banner.diagonal_right.cyan": "Trinxat, 1r cian",
  "block.minecraft.banner.diagonal_right.gray": "Trinxat, 1r gris",
  "block.minecraft.banner.diagonal_right.green": "Trinxat, 1r de sinople",
  "block.minecraft.banner.diagonal_right.light_blue": "Trinxat, 1r blau cel",
  "block.minecraft.banner.diagonal_right.light_gray": "Trinxat, 1r d'argent",
  "block.minecraft.banner.diagonal_right.lime": "Trinxat, 1r llima",
  "block.minecraft.banner.diagonal_right.magenta": "Trinxat, 1r magenta",
  "block.minecraft.banner.diagonal_right.orange": "Trinxat, 1r ataronjat",
  "block.minecraft.banner.diagonal_right.pink": "Trinxat, 1r rosa",
  "block.minecraft.banner.diagonal_right.purple": "Trinxat, 1r de porpra",
  "block.minecraft.banner.diagonal_right.red": "Trinxat, 1r de gules",
  "block.minecraft.banner.diagonal_right.white": "Trinxat, 1r blanc",
  "block.minecraft.banner.diagonal_right.yellow": "Trinxat, 1r d'or",
  "block.minecraft.banner.diagonal_up_left.black": "Trinxat, 2n de sable",
  "block.minecraft.banner.diagonal_up_left.blue": "Trinxat, 2n d'atzur",
  "block.minecraft.banner.diagonal_up_left.brown": "Trinxat, 2n marró",
  "block.minecraft.banner.diagonal_up_left.cyan": "Trinxat, 2n cian",
  "block.minecraft.banner.diagonal_up_left.gray": "Trinxat, 2n gris",
  "block.minecraft.banner.diagonal_up_left.green": "Trinxat, 2n de sinople",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Trinxat, 2n blau cel",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Trinxat, 2n d'argent",
  "block.minecraft.banner.diagonal_up_left.lime": "Trinxat, 2n llima",
  "block.minecraft.banner.diagonal_up_left.magenta": "Trinxat, 2n magenta",
  "block.minecraft.banner.diagonal_up_left.orange": "Trinxat, 2n ataronjat",
  "block.minecraft.banner.diagonal_up_left.pink": "Trinxat, 2n rosa",
  "block.minecraft.banner.diagonal_up_left.purple": "Trinxat, 2n de porpra",
  "block.minecraft.banner.diagonal_up_left.red": "Trinxat, 2n de gules",
  "block.minecraft.banner.diagonal_up_left.white": "Trinxat, 2n blanc",
  "block.minecraft.banner.diagonal_up_left.yellow": "Trinxat, 2n d'or",
  "block.minecraft.banner.diagonal_up_right.black": "Tallat, 2n de sable",
  "block.minecraft.banner.diagonal_up_right.blue": "Tallat, 2n d'atzur",
  "block.minecraft.banner.diagonal_up_right.brown": "Tallat, 2n marró",
  "block.minecraft.banner.diagonal_up_right.cyan": "Tallat, 2n cian",
  "block.minecraft.banner.diagonal_up_right.gray": "Tallat, 2n gris",
  "block.minecraft.banner.diagonal_up_right.green": "Tallat, 2n de sinople",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Tallat, 2n blau cel",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Tallat, 2n d'argent",
  "block.minecraft.banner.diagonal_up_right.lime": "Tallat, 2n llima",
  "block.minecraft.banner.diagonal_up_right.magenta": "Tallat, 2n magenta",
  "block.minecraft.banner.diagonal_up_right.orange": "Tallat, 2n ataronjat",
  "block.minecraft.banner.diagonal_up_right.pink": "Tallat, 2n rosa",
  "block.minecraft.banner.diagonal_up_right.purple": "Tallat, 2n de porpra",
  "block.minecraft.banner.diagonal_up_right.red": "Tallat, 2n de gules",
  "block.minecraft.banner.diagonal_up_right.white": "Tallat, 2n blanc",
  "block.minecraft.banner.diagonal_up_right.yellow": "Tallat, 2n d'or",
  "block.minecraft.banner.flow.black": "Espiral negre",
  "block.minecraft.banner.flow.blue": "Espiral blau",
  "block.minecraft.banner.flow.brown": "Espiral marró",
  "block.minecraft.banner.flow.cyan": "Espiral cian",
  "block.minecraft.banner.flow.gray": "Espiral gris",
  "block.minecraft.banner.flow.green": "Espiral verd",
  "block.minecraft.banner.flow.light_blue": "Espiral blau cel",
  "block.minecraft.banner.flow.light_gray": "Espiral gris clar",
  "block.minecraft.banner.flow.lime": "Espiral llima",
  "block.minecraft.banner.flow.magenta": "Espiral magenta",
  "block.minecraft.banner.flow.orange": "Espiral taronja",
  "block.minecraft.banner.flow.pink": "Espiral rosa",
  "block.minecraft.banner.flow.purple": "Espiral morat",
  "block.minecraft.banner.flow.red": "Espiral vermell",
  "block.minecraft.banner.flow.white": "Espiral blanc",
  "block.minecraft.banner.flow.yellow": "Espiral groc",
  "block.minecraft.banner.flower.black": "Flor de sable",
  "block.minecraft.banner.flower.blue": "Flor d'atzur",
  "block.minecraft.banner.flower.brown": "Flor marró",
  "block.minecraft.banner.flower.cyan": "Flor cian",
  "block.minecraft.banner.flower.gray": "Flor gris",
  "block.minecraft.banner.flower.green": "Flor de sinople",
  "block.minecraft.banner.flower.light_blue": "Flor blau cel",
  "block.minecraft.banner.flower.light_gray": "Flor d'argent",
  "block.minecraft.banner.flower.lime": "Flor llima",
  "block.minecraft.banner.flower.magenta": "Flor magenta",
  "block.minecraft.banner.flower.orange": "Flor ataronjada",
  "block.minecraft.banner.flower.pink": "Flor rosa",
  "block.minecraft.banner.flower.purple": "Flor de porpra",
  "block.minecraft.banner.flower.red": "Flor de gules",
  "block.minecraft.banner.flower.white": "Flor blanca",
  "block.minecraft.banner.flower.yellow": "Flor d'or",
  "block.minecraft.banner.globe.black": "Planeta de sable",
  "block.minecraft.banner.globe.blue": "Planeta blau",
  "block.minecraft.banner.globe.brown": "Planeta marró",
  "block.minecraft.banner.globe.cyan": "Planeta cian",
  "block.minecraft.banner.globe.gray": "Planeta gris",
  "block.minecraft.banner.globe.green": "Planeta verd",
  "block.minecraft.banner.globe.light_blue": "Planeta blau cel",
  "block.minecraft.banner.globe.light_gray": "Planeta gris clar",
  "block.minecraft.banner.globe.lime": "Planeta llima",
  "block.minecraft.banner.globe.magenta": "Planeta magenta",
  "block.minecraft.banner.globe.orange": "Planeta taronja",
  "block.minecraft.banner.globe.pink": "Planeta rosa",
  "block.minecraft.banner.globe.purple": "Planeta morat",
  "block.minecraft.banner.globe.red": "Planeta roig",
  "block.minecraft.banner.globe.white": "Planeta blanc",
  "block.minecraft.banner.globe.yellow": "Planeta groc",
  "block.minecraft.banner.gradient.black": "Degradat de sable",
  "block.minecraft.banner.gradient.blue": "Degradat d'atzur",
  "block.minecraft.banner.gradient.brown": "Degradat marró",
  "block.minecraft.banner.gradient.cyan": "Degradat cian",
  "block.minecraft.banner.gradient.gray": "Degradat gris",
  "block.minecraft.banner.gradient.green": "Degradat de sinople",
  "block.minecraft.banner.gradient.light_blue": "Degradat blau cel",
  "block.minecraft.banner.gradient.light_gray": "Degradat d'argent",
  "block.minecraft.banner.gradient.lime": "Degradat lima",
  "block.minecraft.banner.gradient.magenta": "Degradat magenta",
  "block.minecraft.banner.gradient.orange": "Degradat ataronjat",
  "block.minecraft.banner.gradient.pink": "Degradat rosa",
  "block.minecraft.banner.gradient.purple": "Degradat de porpra",
  "block.minecraft.banner.gradient.red": "Degradat de gules",
  "block.minecraft.banner.gradient.white": "Degradat blanc",
  "block.minecraft.banner.gradient.yellow": "Degradat d'or",
  "block.minecraft.banner.gradient_up.black": "Peu degradat de sable",
  "block.minecraft.banner.gradient_up.blue": "Peu degradat d'atzur",
  "block.minecraft.banner.gradient_up.brown": "Peu degradat marró",
  "block.minecraft.banner.gradient_up.cyan": "Peu degradat cian",
  "block.minecraft.banner.gradient_up.gray": "Peu degradat gris",
  "block.minecraft.banner.gradient_up.green": "Peu degradat de sinople",
  "block.minecraft.banner.gradient_up.light_blue": "Peu degradat blau cel",
  "block.minecraft.banner.gradient_up.light_gray": "Peu degradat d'argent",
  "block.minecraft.banner.gradient_up.lime": "Peu degradat lima",
  "block.minecraft.banner.gradient_up.magenta": "Peu degradat magenta",
  "block.minecraft.banner.gradient_up.orange": "Peu degradat ataronjat",
  "block.minecraft.banner.gradient_up.pink": "Peu degradat rosa",
  "block.minecraft.banner.gradient_up.purple": "Peu degradat de porpra",
  "block.minecraft.banner.gradient_up.red": "Peu degradat de gules",
  "block.minecraft.banner.gradient_up.white": "Peu degradat blanc",
  "block.minecraft.banner.gradient_up.yellow": "Peu degradat d'or",
  "block.minecraft.banner.guster.black": "Brisa negra",
  "block.minecraft.banner.guster.blue": "Brisa blava",
  "block.minecraft.banner.guster.brown": "Brisa marró",
  "block.minecraft.banner.guster.cyan": "Brisa cian",
  "block.minecraft.banner.guster.gray": "Brisa grisa",
  "block.minecraft.banner.guster.green": "Brisa verda",
  "block.minecraft.banner.guster.light_blue": "Brisa blau cel",
  "block.minecraft.banner.guster.light_gray": "Brisa gris clar",
  "block.minecraft.banner.guster.lime": "Brisa llima",
  "block.minecraft.banner.guster.magenta": "Brisa magenta",
  "block.minecraft.banner.guster.orange": "Brisa taronja",
  "block.minecraft.banner.guster.pink": "Brisa rosa",
  "block.minecraft.banner.guster.purple": "Brisa morada",
  "block.minecraft.banner.guster.red": "Brisa vermella",
  "block.minecraft.banner.guster.white": "Brisa blanca",
  "block.minecraft.banner.guster.yellow": "Brisa groga",
  "block.minecraft.banner.half_horizontal.black": "Truncat, 1r de sable",
  "block.minecraft.banner.half_horizontal.blue": "Truncat, 1r d'atzur",
  "block.minecraft.banner.half_horizontal.brown": "Truncat, 1r marró",
  "block.minecraft.banner.half_horizontal.cyan": "Truncat, 1r cian",
  "block.minecraft.banner.half_horizontal.gray": "Truncat, 1r gris",
  "block.minecraft.banner.half_horizontal.green": "Truncat, 1r de sinople",
  "block.minecraft.banner.half_horizontal.light_blue": "Truncat, 1r blau cel",
  "block.minecraft.banner.half_horizontal.light_gray": "Truncat, 1r d'argent",
  "block.minecraft.banner.half_horizontal.lime": "Truncat, 1r llima",
  "block.minecraft.banner.half_horizontal.magenta": "Truncat, 1r magenta",
  "block.minecraft.banner.half_horizontal.orange": "Truncat, 1r ataronjat",
  "block.minecraft.banner.half_horizontal.pink": "Truncat, 1r rosa",
  "block.minecraft.banner.half_horizontal.purple": "Truncat, 1r de porpra",
  "block.minecraft.banner.half_horizontal.red": "Truncat, 1r de gules",
  "block.minecraft.banner.half_horizontal.white": "Truncat, 1r blanc",
  "block.minecraft.banner.half_horizontal.yellow": "Truncat, 1r d'or",
  "block.minecraft.banner.half_horizontal_bottom.black": "Truncat, 2n de sable",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Truncat, 2n d'atzur",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Truncat, 2n marró",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Truncat, 2n cian",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Truncat, 2n gris",
  "block.minecraft.banner.half_horizontal_bottom.green": "Truncat, 2n de sinople",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Truncat, 2n blau cel",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Truncat, 2n d'argent",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Truncat, 2n llima",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Truncat, 2n magenta",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Truncat, 2n ataronjat",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Truncat, 2n rosa",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Truncat, 2n de porpra",
  "block.minecraft.banner.half_horizontal_bottom.red": "Truncat, 2n de gules",
  "block.minecraft.banner.half_horizontal_bottom.white": "Truncat, 2n blanc",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Truncat, 2n d'or",
  "block.minecraft.banner.half_vertical.black": "Partit, 1r de sable",
  "block.minecraft.banner.half_vertical.blue": "Partit, 1r d'atzur",
  "block.minecraft.banner.half_vertical.brown": "Partit, 1r marró",
  "block.minecraft.banner.half_vertical.cyan": "Partit, 1r cian",
  "block.minecraft.banner.half_vertical.gray": "Partit, 1r gris",
  "block.minecraft.banner.half_vertical.green": "Partit, 1r de sinople",
  "block.minecraft.banner.half_vertical.light_blue": "Partit, 1r blau cel",
  "block.minecraft.banner.half_vertical.light_gray": "Partit, 1r d'argent",
  "block.minecraft.banner.half_vertical.lime": "Partit, 1r llima",
  "block.minecraft.banner.half_vertical.magenta": "Partit, 1r magenta",
  "block.minecraft.banner.half_vertical.orange": "Partit, 1r ataronjat",
  "block.minecraft.banner.half_vertical.pink": "Partit, 1r rosa",
  "block.minecraft.banner.half_vertical.purple": "Partit, 1r de porpra",
  "block.minecraft.banner.half_vertical.red": "Partit, 1r de gules",
  "block.minecraft.banner.half_vertical.white": "Partit, 1r blanc",
  "block.minecraft.banner.half_vertical.yellow": "Partit, 1r d'or",
  "block.minecraft.banner.half_vertical_right.black": "Partit, 2n de sable",
  "block.minecraft.banner.half_vertical_right.blue": "Partit, 2n d'atzur",
  "block.minecraft.banner.half_vertical_right.brown": "Partit, 2n marró",
  "block.minecraft.banner.half_vertical_right.cyan": "Partit, 2n cian",
  "block.minecraft.banner.half_vertical_right.gray": "Partit, 2n gris",
  "block.minecraft.banner.half_vertical_right.green": "Partit, 2n de sinople",
  "block.minecraft.banner.half_vertical_right.light_blue": "Partit, 2n blau cel",
  "block.minecraft.banner.half_vertical_right.light_gray": "Partit, 2n d'argent",
  "block.minecraft.banner.half_vertical_right.lime": "Partit, 2n llima",
  "block.minecraft.banner.half_vertical_right.magenta": "Partit, 2n magenta",
  "block.minecraft.banner.half_vertical_right.orange": "Partit, 2n ataronjat",
  "block.minecraft.banner.half_vertical_right.pink": "Partit, 2n rosa",
  "block.minecraft.banner.half_vertical_right.purple": "Partit, 2n de porpra",
  "block.minecraft.banner.half_vertical_right.red": "Partit, 2n de gules",
  "block.minecraft.banner.half_vertical_right.white": "Partit, 2n blanc",
  "block.minecraft.banner.half_vertical_right.yellow": "Partit, 2n d'or",
  "block.minecraft.banner.mojang.black": "Emblema de sable",
  "block.minecraft.banner.mojang.blue": "Emblema d'atzur",
  "block.minecraft.banner.mojang.brown": "Emblema marró",
  "block.minecraft.banner.mojang.cyan": "Emblema cian",
  "block.minecraft.banner.mojang.gray": "Emblema gris",
  "block.minecraft.banner.mojang.green": "Emblema de sinople",
  "block.minecraft.banner.mojang.light_blue": "Emblema blau cel",
  "block.minecraft.banner.mojang.light_gray": "Emblema d'argent",
  "block.minecraft.banner.mojang.lime": "Emblema llima",
  "block.minecraft.banner.mojang.magenta": "Emblema magenta",
  "block.minecraft.banner.mojang.orange": "Emblema ataronjat",
  "block.minecraft.banner.mojang.pink": "Emblema rosa",
  "block.minecraft.banner.mojang.purple": "Emblema de porpra",
  "block.minecraft.banner.mojang.red": "Emblema de gules",
  "block.minecraft.banner.mojang.white": "Emblema blanc",
  "block.minecraft.banner.mojang.yellow": "Emblema d'or",
  "block.minecraft.banner.piglin.black": "Morro de sable",
  "block.minecraft.banner.piglin.blue": "Morro d'atzur",
  "block.minecraft.banner.piglin.brown": "Morro marró",
  "block.minecraft.banner.piglin.cyan": "Morro cian",
  "block.minecraft.banner.piglin.gray": "Morro gris",
  "block.minecraft.banner.piglin.green": "Morro de sinople",
  "block.minecraft.banner.piglin.light_blue": "Morro blau cel",
  "block.minecraft.banner.piglin.light_gray": "Morro d'argent",
  "block.minecraft.banner.piglin.lime": "Morro llima",
  "block.minecraft.banner.piglin.magenta": "Morro magenta",
  "block.minecraft.banner.piglin.orange": "Morro ataronjat",
  "block.minecraft.banner.piglin.pink": "Morro rosa",
  "block.minecraft.banner.piglin.purple": "Morro porpra",
  "block.minecraft.banner.piglin.red": "Morro de gules",
  "block.minecraft.banner.piglin.white": "Morro blanc",
  "block.minecraft.banner.piglin.yellow": "Morro d'or",
  "block.minecraft.banner.rhombus.black": "Losange de sable",
  "block.minecraft.banner.rhombus.blue": "Losange d'atzur",
  "block.minecraft.banner.rhombus.brown": "Losange marró",
  "block.minecraft.banner.rhombus.cyan": "Losange cian",
  "block.minecraft.banner.rhombus.gray": "Losange gris",
  "block.minecraft.banner.rhombus.green": "Losange de sinople",
  "block.minecraft.banner.rhombus.light_blue": "Losange blau cel",
  "block.minecraft.banner.rhombus.light_gray": "Losange d'argent",
  "block.minecraft.banner.rhombus.lime": "Losange llima",
  "block.minecraft.banner.rhombus.magenta": "Losange magenta",
  "block.minecraft.banner.rhombus.orange": "Losange ataronjada",
  "block.minecraft.banner.rhombus.pink": "Losange rosa",
  "block.minecraft.banner.rhombus.purple": "Losange de porpra",
  "block.minecraft.banner.rhombus.red": "Losange de gules",
  "block.minecraft.banner.rhombus.white": "Losange blanca",
  "block.minecraft.banner.rhombus.yellow": "Losange d'or",
  "block.minecraft.banner.skull.black": "Calavera de sable",
  "block.minecraft.banner.skull.blue": "Calavera d'atzur",
  "block.minecraft.banner.skull.brown": "Calavera marró",
  "block.minecraft.banner.skull.cyan": "Calavera cian",
  "block.minecraft.banner.skull.gray": "Calavera grisa",
  "block.minecraft.banner.skull.green": "Calavera de sinople",
  "block.minecraft.banner.skull.light_blue": "Calavera blau cel",
  "block.minecraft.banner.skull.light_gray": "Calavera d'argent",
  "block.minecraft.banner.skull.lime": "Calavera llima",
  "block.minecraft.banner.skull.magenta": "Calavera magenta",
  "block.minecraft.banner.skull.orange": "Calavera ataronjada",
  "block.minecraft.banner.skull.pink": "Calavera rosa",
  "block.minecraft.banner.skull.purple": "Calavera de porpra",
  "block.minecraft.banner.skull.red": "Calavera de gules",
  "block.minecraft.banner.skull.white": "Calavera blanca",
  "block.minecraft.banner.skull.yellow": "Calavera d'or",
  "block.minecraft.banner.small_stripes.black": "Quatre pals de sable",
  "block.minecraft.banner.small_stripes.blue": "Quatre pals d'atzur",
  "block.minecraft.banner.small_stripes.brown": "Quatre pals marrons",
  "block.minecraft.banner.small_stripes.cyan": "Quatre pals cian",
  "block.minecraft.banner.small_stripes.gray": "Quatre pals grisos",
  "block.minecraft.banner.small_stripes.green": "Quatre pals de sinople",
  "block.minecraft.banner.small_stripes.light_blue": "Quatre pals blau cel",
  "block.minecraft.banner.small_stripes.light_gray": "Quatre pals d'argent",
  "block.minecraft.banner.small_stripes.lime": "Quatre pals llima",
  "block.minecraft.banner.small_stripes.magenta": "Quatre pals magenta",
  "block.minecraft.banner.small_stripes.orange": "Quatre pals ataronjats",
  "block.minecraft.banner.small_stripes.pink": "Quatre pals rosa",
  "block.minecraft.banner.small_stripes.purple": "Quatre pals de porpra",
  "block.minecraft.banner.small_stripes.red": "Quatre pals de gules",
  "block.minecraft.banner.small_stripes.white": "Quatre pals blancs",
  "block.minecraft.banner.small_stripes.yellow": "Quatre pals d'or",
  "block.minecraft.banner.square_bottom_left.black": "Cantó destre de la punta de sable",
  "block.minecraft.banner.square_bottom_left.blue": "Cantó destre de la punta d'atzur",
  "block.minecraft.banner.square_bottom_left.brown": "Cantó destre de la punta marró",
  "block.minecraft.banner.square_bottom_left.cyan": "Cantó destre de la punta cian",
  "block.minecraft.banner.square_bottom_left.gray": "Cantó destre de la punta gris",
  "block.minecraft.banner.square_bottom_left.green": "Cantó destre de la punta de sinople",
  "block.minecraft.banner.square_bottom_left.light_blue": "Cantó destre de la punta blau cel",
  "block.minecraft.banner.square_bottom_left.light_gray": "Cantó destre de la punta d'argent",
  "block.minecraft.banner.square_bottom_left.lime": "Cantó destre de la punta llima",
  "block.minecraft.banner.square_bottom_left.magenta": "Cantó destre de la punta magenta",
  "block.minecraft.banner.square_bottom_left.orange": "Cantó destre de la punta ataronjat",
  "block.minecraft.banner.square_bottom_left.pink": "Cantó destre de la punta rosa",
  "block.minecraft.banner.square_bottom_left.purple": "Cantó destre de la punta de porpra",
  "block.minecraft.banner.square_bottom_left.red": "Cantó destre de la punta de gules",
  "block.minecraft.banner.square_bottom_left.white": "Cantó destre de la punta blanc",
  "block.minecraft.banner.square_bottom_left.yellow": "Cantó destre de la punta d'or",
  "block.minecraft.banner.square_bottom_right.black": "Cantó sinistre de la punta de sable",
  "block.minecraft.banner.square_bottom_right.blue": "Cantó sinistre de la punta d'atzur",
  "block.minecraft.banner.square_bottom_right.brown": "Cantó sinistre de la punta marró",
  "block.minecraft.banner.square_bottom_right.cyan": "Cantó sinistre de la punta cian",
  "block.minecraft.banner.square_bottom_right.gray": "Cantó sinistre de la punta gris",
  "block.minecraft.banner.square_bottom_right.green": "Cantó sinistre de la punta de sinople",
  "block.minecraft.banner.square_bottom_right.light_blue": "Cantó sinistre de la punta blau cel",
  "block.minecraft.banner.square_bottom_right.light_gray": "Cantó sinistre de la punta d'argent",
  "block.minecraft.banner.square_bottom_right.lime": "Cantó sinistre de la punta llima",
  "block.minecraft.banner.square_bottom_right.magenta": "Cantó sinistre de la punta magenta",
  "block.minecraft.banner.square_bottom_right.orange": "Cantó sinistre de la punta ataronjat",
  "block.minecraft.banner.square_bottom_right.pink": "Cantó sinistre de la punta rosa",
  "block.minecraft.banner.square_bottom_right.purple": "Cantó sinistre de la punta de porpra",
  "block.minecraft.banner.square_bottom_right.red": "Cantó sinistre de la punta de gules",
  "block.minecraft.banner.square_bottom_right.white": "Cantó sinistre de la punta blanc",
  "block.minecraft.banner.square_bottom_right.yellow": "Cantó sinistre de la punta d'or",
  "block.minecraft.banner.square_top_left.black": "Cantó destre del cap de sable",
  "block.minecraft.banner.square_top_left.blue": "Cantó destre del cap d'atzur",
  "block.minecraft.banner.square_top_left.brown": "Cantó destre del cap marró",
  "block.minecraft.banner.square_top_left.cyan": "Cantó destre del cap cian",
  "block.minecraft.banner.square_top_left.gray": "Cantó destre del cap gris",
  "block.minecraft.banner.square_top_left.green": "Cantó destre del cap de sinople",
  "block.minecraft.banner.square_top_left.light_blue": "Cantó destre del cap blau cel",
  "block.minecraft.banner.square_top_left.light_gray": "Cantó destre del cap d'argent",
  "block.minecraft.banner.square_top_left.lime": "Cantó destre del cap llima",
  "block.minecraft.banner.square_top_left.magenta": "Cantó destre del cap magenta",
  "block.minecraft.banner.square_top_left.orange": "Cantó destre del cap ataronjat",
  "block.minecraft.banner.square_top_left.pink": "Cantó destre del cap rosa",
  "block.minecraft.banner.square_top_left.purple": "Cantó destre del cap de porpra",
  "block.minecraft.banner.square_top_left.red": "Cantó destre del cap de gules",
  "block.minecraft.banner.square_top_left.white": "Cantó destre del cap blanc",
  "block.minecraft.banner.square_top_left.yellow": "Cantó destre del cap d'or",
  "block.minecraft.banner.square_top_right.black": "Cantó sinistre del cap de sable",
  "block.minecraft.banner.square_top_right.blue": "Cantó sinistre del cap d'atzur",
  "block.minecraft.banner.square_top_right.brown": "Cantó sinistre del cap marró",
  "block.minecraft.banner.square_top_right.cyan": "Cantó sinistre del cap cian",
  "block.minecraft.banner.square_top_right.gray": "Cantó sinistre del cap gris",
  "block.minecraft.banner.square_top_right.green": "Cantó sinistre del cap de sinople",
  "block.minecraft.banner.square_top_right.light_blue": "Cantó sinistre del cap blau cel",
  "block.minecraft.banner.square_top_right.light_gray": "Cantó sinistre del cap d'argent",
  "block.minecraft.banner.square_top_right.lime": "Cantó sinistre del cap llima",
  "block.minecraft.banner.square_top_right.magenta": "Cantó sinistre del cap magenta",
  "block.minecraft.banner.square_top_right.orange": "Cantó sinistre del cap ataronjat",
  "block.minecraft.banner.square_top_right.pink": "Cantó sinistre del cap rosa",
  "block.minecraft.banner.square_top_right.purple": "Cantó sinistre del cap de porpra",
  "block.minecraft.banner.square_top_right.red": "Cantó sinistre del cap de gules",
  "block.minecraft.banner.square_top_right.white": "Cantó sinistre del cap blanc",
  "block.minecraft.banner.square_top_right.yellow": "Cantó sinistre del cap d'or",
  "block.minecraft.banner.straight_cross.black": "Creu de sable",
  "block.minecraft.banner.straight_cross.blue": "Creu d'atzur",
  "block.minecraft.banner.straight_cross.brown": "Creu marró",
  "block.minecraft.banner.straight_cross.cyan": "Creu cian",
  "block.minecraft.banner.straight_cross.gray": "Creu grisa",
  "block.minecraft.banner.straight_cross.green": "Creu de sinople",
  "block.minecraft.banner.straight_cross.light_blue": "Creu blau cel",
  "block.minecraft.banner.straight_cross.light_gray": "Creu d'argent",
  "block.minecraft.banner.straight_cross.lime": "Creu llima",
  "block.minecraft.banner.straight_cross.magenta": "Creu magenta",
  "block.minecraft.banner.straight_cross.orange": "Creu ataronjada",
  "block.minecraft.banner.straight_cross.pink": "Creu rosa",
  "block.minecraft.banner.straight_cross.purple": "Creu de porpra",
  "block.minecraft.banner.straight_cross.red": "Creu de gules",
  "block.minecraft.banner.straight_cross.white": "Creu blanca",
  "block.minecraft.banner.straight_cross.yellow": "Creu d'or",
  "block.minecraft.banner.stripe_bottom.black": "Peu de sable",
  "block.minecraft.banner.stripe_bottom.blue": "Peu d'atzur",
  "block.minecraft.banner.stripe_bottom.brown": "Peu marró",
  "block.minecraft.banner.stripe_bottom.cyan": "Peu cian",
  "block.minecraft.banner.stripe_bottom.gray": "Peu gris",
  "block.minecraft.banner.stripe_bottom.green": "Peu de sinople",
  "block.minecraft.banner.stripe_bottom.light_blue": "Peu blau cel",
  "block.minecraft.banner.stripe_bottom.light_gray": "Peu d'argent",
  "block.minecraft.banner.stripe_bottom.lime": "Peu llima",
  "block.minecraft.banner.stripe_bottom.magenta": "Peu magenta",
  "block.minecraft.banner.stripe_bottom.orange": "Peu ataronjat",
  "block.minecraft.banner.stripe_bottom.pink": "Peu rosa",
  "block.minecraft.banner.stripe_bottom.purple": "Peu de porpra",
  "block.minecraft.banner.stripe_bottom.red": "Peu de gules",
  "block.minecraft.banner.stripe_bottom.white": "Peu blanc",
  "block.minecraft.banner.stripe_bottom.yellow": "Peu d'or",
  "block.minecraft.banner.stripe_center.black": "Pal de sable",
  "block.minecraft.banner.stripe_center.blue": "Pal d'atzur",
  "block.minecraft.banner.stripe_center.brown": "Pal marró",
  "block.minecraft.banner.stripe_center.cyan": "Pal cian",
  "block.minecraft.banner.stripe_center.gray": "Pal gris",
  "block.minecraft.banner.stripe_center.green": "Pal de sinople",
  "block.minecraft.banner.stripe_center.light_blue": "Pal blau cel",
  "block.minecraft.banner.stripe_center.light_gray": "Pal d'argent",
  "block.minecraft.banner.stripe_center.lime": "Pal llima",
  "block.minecraft.banner.stripe_center.magenta": "Pal magenta",
  "block.minecraft.banner.stripe_center.orange": "Pal ataronjat",
  "block.minecraft.banner.stripe_center.pink": "Pal rosa",
  "block.minecraft.banner.stripe_center.purple": "Pal de porpra",
  "block.minecraft.banner.stripe_center.red": "Pal de gules",
  "block.minecraft.banner.stripe_center.white": "Pal blanc",
  "block.minecraft.banner.stripe_center.yellow": "Pal d'or",
  "block.minecraft.banner.stripe_downleft.black": "Barra de sable",
  "block.minecraft.banner.stripe_downleft.blue": "Barra d'atzur",
  "block.minecraft.banner.stripe_downleft.brown": "Barra marró",
  "block.minecraft.banner.stripe_downleft.cyan": "Barra cian",
  "block.minecraft.banner.stripe_downleft.gray": "Barra grisa",
  "block.minecraft.banner.stripe_downleft.green": "Barra de sinople",
  "block.minecraft.banner.stripe_downleft.light_blue": "Barra blau cel",
  "block.minecraft.banner.stripe_downleft.light_gray": "Barra d'argent",
  "block.minecraft.banner.stripe_downleft.lime": "Barra llima",
  "block.minecraft.banner.stripe_downleft.magenta": "Barra magenta",
  "block.minecraft.banner.stripe_downleft.orange": "Barra ataronjada",
  "block.minecraft.banner.stripe_downleft.pink": "Barra rosa",
  "block.minecraft.banner.stripe_downleft.purple": "Barra de porpra",
  "block.minecraft.banner.stripe_downleft.red": "Barra de gules",
  "block.minecraft.banner.stripe_downleft.white": "Barra blanca",
  "block.minecraft.banner.stripe_downleft.yellow": "Barra d'or",
  "block.minecraft.banner.stripe_downright.black": "Banda de sable",
  "block.minecraft.banner.stripe_downright.blue": "Banda d'atzur",
  "block.minecraft.banner.stripe_downright.brown": "Banda marró",
  "block.minecraft.banner.stripe_downright.cyan": "Banda cian",
  "block.minecraft.banner.stripe_downright.gray": "Banda grisa",
  "block.minecraft.banner.stripe_downright.green": "Banda de sinople",
  "block.minecraft.banner.stripe_downright.light_blue": "Banda blau cel",
  "block.minecraft.banner.stripe_downright.light_gray": "Banda d'argent",
  "block.minecraft.banner.stripe_downright.lime": "Banda llima",
  "block.minecraft.banner.stripe_downright.magenta": "Banda magenta",
  "block.minecraft.banner.stripe_downright.orange": "Banda ataronjada",
  "block.minecraft.banner.stripe_downright.pink": "Banda rosa",
  "block.minecraft.banner.stripe_downright.purple": "Banda de porpra",
  "block.minecraft.banner.stripe_downright.red": "Banda de gules",
  "block.minecraft.banner.stripe_downright.white": "Banda blanca",
  "block.minecraft.banner.stripe_downright.yellow": "Banda d'or",
  "block.minecraft.banner.stripe_left.black": "Dextrat de sable",
  "block.minecraft.banner.stripe_left.blue": "Dextrat d'atzur",
  "block.minecraft.banner.stripe_left.brown": "Dextrat marró",
  "block.minecraft.banner.stripe_left.cyan": "Dextrat cian",
  "block.minecraft.banner.stripe_left.gray": "Dextrat gris",
  "block.minecraft.banner.stripe_left.green": "Dextrat de sinople",
  "block.minecraft.banner.stripe_left.light_blue": "Dextrat blau cel",
  "block.minecraft.banner.stripe_left.light_gray": "Dextrat d'argent",
  "block.minecraft.banner.stripe_left.lime": "Dextrat llima",
  "block.minecraft.banner.stripe_left.magenta": "Dextrat magenta",
  "block.minecraft.banner.stripe_left.orange": "Dextrat ataronjat",
  "block.minecraft.banner.stripe_left.pink": "Dextrat rosa",
  "block.minecraft.banner.stripe_left.purple": "Dextrat de porpra",
  "block.minecraft.banner.stripe_left.red": "Dextrat de gules",
  "block.minecraft.banner.stripe_left.white": "Dextrat blanc",
  "block.minecraft.banner.stripe_left.yellow": "Dextrat d'or",
  "block.minecraft.banner.stripe_middle.black": "Faixa de sable",
  "block.minecraft.banner.stripe_middle.blue": "Faixa d'atzur",
  "block.minecraft.banner.stripe_middle.brown": "Faixa marró",
  "block.minecraft.banner.stripe_middle.cyan": "Faixa cian",
  "block.minecraft.banner.stripe_middle.gray": "Faixa grisa",
  "block.minecraft.banner.stripe_middle.green": "Faixa de sinople",
  "block.minecraft.banner.stripe_middle.light_blue": "Faixa blau cel",
  "block.minecraft.banner.stripe_middle.light_gray": "Faixa d'argent",
  "block.minecraft.banner.stripe_middle.lime": "Faixa llima",
  "block.minecraft.banner.stripe_middle.magenta": "Faixa magenta",
  "block.minecraft.banner.stripe_middle.orange": "Faixa ataronjada",
  "block.minecraft.banner.stripe_middle.pink": "Faixa rosa",
  "block.minecraft.banner.stripe_middle.purple": "Faixa de porpra",
  "block.minecraft.banner.stripe_middle.red": "Faixa de gules",
  "block.minecraft.banner.stripe_middle.white": "Faixa blanca",
  "block.minecraft.banner.stripe_middle.yellow": "Faixa d'or",
  "block.minecraft.banner.stripe_right.black": "Sinistrat de sable",
  "block.minecraft.banner.stripe_right.blue": "Sinistrat d'atzur",
  "block.minecraft.banner.stripe_right.brown": "Sinistrat marró",
  "block.minecraft.banner.stripe_right.cyan": "Sinistrat cian",
  "block.minecraft.banner.stripe_right.gray": "Sinistrat gris",
  "block.minecraft.banner.stripe_right.green": "Sinistrat de sinople",
  "block.minecraft.banner.stripe_right.light_blue": "Sinistrat blau cel",
  "block.minecraft.banner.stripe_right.light_gray": "Sinistrat d'argent",
  "block.minecraft.banner.stripe_right.lime": "Sinistrat llima",
  "block.minecraft.banner.stripe_right.magenta": "Sinistrat magenta",
  "block.minecraft.banner.stripe_right.orange": "Sinistrat ataronjat",
  "block.minecraft.banner.stripe_right.pink": "Sinistrat rosa",
  "block.minecraft.banner.stripe_right.purple": "Sinistrat de porpra",
  "block.minecraft.banner.stripe_right.red": "Sinistrat de gules",
  "block.minecraft.banner.stripe_right.white": "Sinistrat blanc",
  "block.minecraft.banner.stripe_right.yellow": "Sinistrat d'or",
  "block.minecraft.banner.stripe_top.black": "Cap de sable",
  "block.minecraft.banner.stripe_top.blue": "Cap d'atzur",
  "block.minecraft.banner.stripe_top.brown": "Cap marró",
  "block.minecraft.banner.stripe_top.cyan": "Cap cian",
  "block.minecraft.banner.stripe_top.gray": "Cap gris",
  "block.minecraft.banner.stripe_top.green": "Cap de sinople",
  "block.minecraft.banner.stripe_top.light_blue": "Cap blau cel",
  "block.minecraft.banner.stripe_top.light_gray": "Cap d'argent",
  "block.minecraft.banner.stripe_top.lime": "Cap llima",
  "block.minecraft.banner.stripe_top.magenta": "Cap magenta",
  "block.minecraft.banner.stripe_top.orange": "Cap ataronjat",
  "block.minecraft.banner.stripe_top.pink": "Cap rosa",
  "block.minecraft.banner.stripe_top.purple": "Cap de porpra",
  "block.minecraft.banner.stripe_top.red": "Cap de gules",
  "block.minecraft.banner.stripe_top.white": "Cap blanc",
  "block.minecraft.banner.stripe_top.yellow": "Cap d'or",
  "block.minecraft.banner.triangle_bottom.black": "Gaiat a la punta de sable",
  "block.minecraft.banner.triangle_bottom.blue": "Gaiat a la punta d'atzur",
  "block.minecraft.banner.triangle_bottom.brown": "Gaiat a la punta marró",
  "block.minecraft.banner.triangle_bottom.cyan": "Gaiat a la punta cian",
  "block.minecraft.banner.triangle_bottom.gray": "Gaiat a la punta gris",
  "block.minecraft.banner.triangle_bottom.green": "Gaiat a la punta de sinople",
  "block.minecraft.banner.triangle_bottom.light_blue": "Gaiat a la punta blau cel",
  "block.minecraft.banner.triangle_bottom.light_gray": "Gaiat a la punta d'argent",
  "block.minecraft.banner.triangle_bottom.lime": "Gaiat a la punta llima",
  "block.minecraft.banner.triangle_bottom.magenta": "Gaiat a la punta magenta",
  "block.minecraft.banner.triangle_bottom.orange": "Gaiat a la punta ataronjat",
  "block.minecraft.banner.triangle_bottom.pink": "Gaiat a la punta rosa",
  "block.minecraft.banner.triangle_bottom.purple": "Gaiat a la punta de porpra",
  "block.minecraft.banner.triangle_bottom.red": "Gaiat a la punta de gules",
  "block.minecraft.banner.triangle_bottom.white": "Gaiat a la punta blanc",
  "block.minecraft.banner.triangle_bottom.yellow": "Gaiat a la punta d'or",
  "block.minecraft.banner.triangle_top.black": "Gaiat al cap de sable",
  "block.minecraft.banner.triangle_top.blue": "Gaiat al cap d'atzur",
  "block.minecraft.banner.triangle_top.brown": "Gaiat al cap marró",
  "block.minecraft.banner.triangle_top.cyan": "Gaiat al cap cian",
  "block.minecraft.banner.triangle_top.gray": "Gaiat al cap gris",
  "block.minecraft.banner.triangle_top.green": "Gaiat al cap de sinople",
  "block.minecraft.banner.triangle_top.light_blue": "Gaiat al cap blau cel",
  "block.minecraft.banner.triangle_top.light_gray": "Gaiat al cap d'argent",
  "block.minecraft.banner.triangle_top.lime": "Gaiat al cap llima",
  "block.minecraft.banner.triangle_top.magenta": "Gaiat al cap magenta",
  "block.minecraft.banner.triangle_top.orange": "Gaiat al cap ataronjat",
  "block.minecraft.banner.triangle_top.pink": "Gaiat al cap rosa",
  "block.minecraft.banner.triangle_top.purple": "Gaiat al cap de porpra",
  "block.minecraft.banner.triangle_top.red": "Gaiat al cap de gules",
  "block.minecraft.banner.triangle_top.white": "Gaiat al cap blanc",
  "block.minecraft.banner.triangle_top.yellow": "Gaiat al cap d'or",
  "block.minecraft.banner.triangles_bottom.black": "Peu dentat de sable",
  "block.minecraft.banner.triangles_bottom.blue": "Peu dentat d'atzur",
  "block.minecraft.banner.triangles_bottom.brown": "Peu dentat marró",
  "block.minecraft.banner.triangles_bottom.cyan": "Peu dentat cian",
  "block.minecraft.banner.triangles_bottom.gray": "Peu dentat gris",
  "block.minecraft.banner.triangles_bottom.green": "Peu dentat de sinople",
  "block.minecraft.banner.triangles_bottom.light_blue": "Peu dentat blau cel",
  "block.minecraft.banner.triangles_bottom.light_gray": "Peu dentat d'argent",
  "block.minecraft.banner.triangles_bottom.lime": "Peu dentat llima",
  "block.minecraft.banner.triangles_bottom.magenta": "Peu dentat magenta",
  "block.minecraft.banner.triangles_bottom.orange": "Peu dentat ataronjat",
  "block.minecraft.banner.triangles_bottom.pink": "Peu dentat rosa",
  "block.minecraft.banner.triangles_bottom.purple": "Peu dentat de porpra",
  "block.minecraft.banner.triangles_bottom.red": "Peu dentat de gules",
  "block.minecraft.banner.triangles_bottom.white": "Peu dentat blanc",
  "block.minecraft.banner.triangles_bottom.yellow": "Peu dentat d'or",
  "block.minecraft.banner.triangles_top.black": "Cap dentat de sable",
  "block.minecraft.banner.triangles_top.blue": "Cap dentat d'atzur",
  "block.minecraft.banner.triangles_top.brown": "Cap dentat marró",
  "block.minecraft.banner.triangles_top.cyan": "Cap dentat cian",
  "block.minecraft.banner.triangles_top.gray": "Cap dentat gris",
  "block.minecraft.banner.triangles_top.green": "Cap dentat de sinople",
  "block.minecraft.banner.triangles_top.light_blue": "Cap dentat blau cel",
  "block.minecraft.banner.triangles_top.light_gray": "Cap dentat d'argent",
  "block.minecraft.banner.triangles_top.lime": "Cap dentat llima",
  "block.minecraft.banner.triangles_top.magenta": "Cap dentat magenta",
  "block.minecraft.banner.triangles_top.orange": "Cap dentat ataronjat",
  "block.minecraft.banner.triangles_top.pink": "Cap dentat rosa",
  "block.minecraft.banner.triangles_top.purple": "Cap dentat de porpra",
  "block.minecraft.banner.triangles_top.red": "Cap dentat de gules",
  "block.minecraft.banner.triangles_top.white": "Cap dentat blanc",
  "block.minecraft.banner.triangles_top.yellow": "Cap dentat d'or",
  "block.minecraft.barrel": "Barril",
  "block.minecraft.barrier": "Barrera",
  "block.minecraft.basalt": "Basalt",
  "block.minecraft.beacon": "Far",
  "block.minecraft.beacon.primary": "Poder primari",
  "block.minecraft.beacon.secondary": "Poder secundari",
  "block.minecraft.bed.no_sleep": "Només pots dormir durant la nit o tempestes",
  "block.minecraft.bed.not_safe": "No hauries de dormir ara, hi ha monstres a prop teu",
  "block.minecraft.bed.obstructed": "El llit està obstruït",
  "block.minecraft.bed.occupied": "Aquest llit està ocupat",
  "block.minecraft.bed.too_far_away": "No hauries de dormir ara, el llit està massa lluny",
  "block.minecraft.bedrock": "Roca base",
  "block.minecraft.bee_nest": "Rusc",
  "block.minecraft.beehive": "Rusc fix",
  "block.minecraft.beetroots": "Remolatxes",
  "block.minecraft.bell": "Campana",
  "block.minecraft.big_dripleaf": "Degotadora gran",
  "block.minecraft.big_dripleaf_stem": "Tija de degotadora gran",
  "block.minecraft.birch_button": "Botó de bedoll",
  "block.minecraft.birch_door": "Porta de fusta de bedoll",
  "block.minecraft.birch_fence": "Tanca de bedoll",
  "block.minecraft.birch_fence_gate": "Porta de tanca de bedoll",
  "block.minecraft.birch_hanging_sign": "Cartell penjant de bedoll",
  "block.minecraft.birch_leaves": "Fulles de bedoll",
  "block.minecraft.birch_log": "Tronc de bedoll",
  "block.minecraft.birch_planks": "Fusta de bedoll",
  "block.minecraft.birch_pressure_plate": "Placa de pressió de bedoll",
  "block.minecraft.birch_sapling": "Esqueix de bedoll",
  "block.minecraft.birch_shelf": "Prestatge de bedoll",
  "block.minecraft.birch_sign": "Cartell de bedoll",
  "block.minecraft.birch_slab": "Llosa de bedoll",
  "block.minecraft.birch_stairs": "Escales de bedoll",
  "block.minecraft.birch_trapdoor": "Trapa de bedoll",
  "block.minecraft.birch_wall_hanging_sign": "Cartell penjant de bedoll amb suport",
  "block.minecraft.birch_wall_sign": "Cartell de bedoll a la paret",
  "block.minecraft.birch_wood": "Fusta de bedoll",
  "block.minecraft.black_banner": "Estendard de sable",
  "block.minecraft.black_bed": "Llit negre",
  "block.minecraft.black_candle": "Espelma negra",
  "block.minecraft.black_candle_cake": "Pastís amb espelma negra",
  "block.minecraft.black_carpet": "Catifa negra",
  "block.minecraft.black_concrete": "Formigó negre",
  "block.minecraft.black_concrete_powder": "Pols de formigó negre",
  "block.minecraft.black_glazed_terracotta": "Rajola negra",
  "block.minecraft.black_shulker_box": "Caixa de shulker negra",
  "block.minecraft.black_stained_glass": "Vidre tenyit de negre",
  "block.minecraft.black_stained_glass_pane": "Panell de vidre tenyit de negre",
  "block.minecraft.black_terracotta": "Terracota negra",
  "block.minecraft.black_wool": "Llana negra",
  "block.minecraft.blackstone": "Roca negra",
  "block.minecraft.blackstone_slab": "Llosa de roca negra",
  "block.minecraft.blackstone_stairs": "Escales de roca negra",
  "block.minecraft.blackstone_wall": "Mur de roca negra",
  "block.minecraft.blast_furnace": "Alt forn",
  "block.minecraft.blue_banner": "Estendard d'atzur",
  "block.minecraft.blue_bed": "Llit blau",
  "block.minecraft.blue_candle": "Espelma blava",
  "block.minecraft.blue_candle_cake": "Pastís amb espelma blava",
  "block.minecraft.blue_carpet": "Catifa blava",
  "block.minecraft.blue_concrete": "Formigó blau",
  "block.minecraft.blue_concrete_powder": "Pols de formigó blau",
  "block.minecraft.blue_glazed_terracotta": "Rajola blava",
  "block.minecraft.blue_ice": "Gel blau",
  "block.minecraft.blue_orchid": "Orquídia blava",
  "block.minecraft.blue_shulker_box": "Caixa de shulker blava",
  "block.minecraft.blue_stained_glass": "Vidre tenyit de blau",
  "block.minecraft.blue_stained_glass_pane": "Panell de vidre tenyit de blau",
  "block.minecraft.blue_terracotta": "Terracota blava",
  "block.minecraft.blue_wool": "Llana blava",
  "block.minecraft.bone_block": "Bloc d'os",
  "block.minecraft.bookshelf": "Llibreria",
  "block.minecraft.brain_coral": "Corall de cervell",
  "block.minecraft.brain_coral_block": "Bloc de corall de cervell",
  "block.minecraft.brain_coral_fan": "Gorgònia de cervell",
  "block.minecraft.brain_coral_wall_fan": "Gorgònia de cervell a la paret",
  "block.minecraft.brewing_stand": "Altar de pocions",
  "block.minecraft.brick_slab": "Llosa de maó",
  "block.minecraft.brick_stairs": "Escales de maó",
  "block.minecraft.brick_wall": "Mur de maó",
  "block.minecraft.bricks": "Maons",
  "block.minecraft.brown_banner": "Estendard marró",
  "block.minecraft.brown_bed": "Llit marró",
  "block.minecraft.brown_candle": "Espelma marró",
  "block.minecraft.brown_candle_cake": "Pastís amb espelma marró",
  "block.minecraft.brown_carpet": "Catifa marró",
  "block.minecraft.brown_concrete": "Formigó marró",
  "block.minecraft.brown_concrete_powder": "Pols de formigó marró",
  "block.minecraft.brown_glazed_terracotta": "Rajola marró",
  "block.minecraft.brown_mushroom": "Bolet marró",
  "block.minecraft.brown_mushroom_block": "Bloc de bolet marró",
  "block.minecraft.brown_shulker_box": "Caixa de shulker marró",
  "block.minecraft.brown_stained_glass": "Vidre tenyit de marró",
  "block.minecraft.brown_stained_glass_pane": "Panell de vidre tenyit de marró",
  "block.minecraft.brown_terracotta": "Terracota marró",
  "block.minecraft.brown_wool": "Llana marró",
  "block.minecraft.bubble_column": "Columna de bombolles",
  "block.minecraft.bubble_coral": "Corall de bombolla",
  "block.minecraft.bubble_coral_block": "Bloc de corall de bombolla",
  "block.minecraft.bubble_coral_fan": "Gorgònia de bombolla",
  "block.minecraft.bubble_coral_wall_fan": "Gorgònia de bombolla a la paret",
  "block.minecraft.budding_amethyst": "Ametista cristal·litzable",
  "block.minecraft.bush": "Matoll",
  "block.minecraft.cactus": "Cactus",
  "block.minecraft.cactus_flower": "Flor de Cactus",
  "block.minecraft.cake": "Pastís",
  "block.minecraft.calcite": "Calcita",
  "block.minecraft.calibrated_sculk_sensor": "Sensor Sculk calibrat",
  "block.minecraft.campfire": "Foguera",
  "block.minecraft.candle": "Espelma",
  "block.minecraft.candle_cake": "Pastís amb espelma",
  "block.minecraft.carrots": "Pastanagues",
  "block.minecraft.cartography_table": "Taula de cartografia",
  "block.minecraft.carved_pumpkin": "Carbassa tallada",
  "block.minecraft.cauldron": "Calderó",
  "block.minecraft.cave_air": "Aire de cova",
  "block.minecraft.cave_vines": "Lianes de cova",
  "block.minecraft.cave_vines_plant": "Planta de lianes de cova",
  "block.minecraft.chain": "Cadena",
  "block.minecraft.chain_command_block": "Bloc de comandaments en cadena",
  "block.minecraft.cherry_button": "Botó de cirerer",
  "block.minecraft.cherry_door": "Porta de cirerer",
  "block.minecraft.cherry_fence": "Tanca de cirerer",
  "block.minecraft.cherry_fence_gate": "Porta de tanca de cirerer",
  "block.minecraft.cherry_hanging_sign": "Cartell penjant de cirerer",
  "block.minecraft.cherry_leaves": "Fulles de cirerer",
  "block.minecraft.cherry_log": "Tronc de cirerer",
  "block.minecraft.cherry_planks": "Fusta de cirerer",
  "block.minecraft.cherry_pressure_plate": "Placa de pressió de cirerer",
  "block.minecraft.cherry_sapling": "Esqueix de cirerer",
  "block.minecraft.cherry_shelf": "Prestatge de cirerer",
  "block.minecraft.cherry_sign": "Cartell de cirerer",
  "block.minecraft.cherry_slab": "Llosa de cirerer",
  "block.minecraft.cherry_stairs": "Escales de cirerer",
  "block.minecraft.cherry_trapdoor": "Trapa de cirerer",
  "block.minecraft.cherry_wall_hanging_sign": "Cartell penjant de cirerer amb suport",
  "block.minecraft.cherry_wall_sign": "Cartell de cirerer a la paret",
  "block.minecraft.cherry_wood": "Fusta de cirerer",
  "block.minecraft.chest": "Cofre",
  "block.minecraft.chipped_anvil": "Enclusa danyada",
  "block.minecraft.chiseled_bookshelf": "Prestatgeria",
  "block.minecraft.chiseled_copper": "Coure cisellat",
  "block.minecraft.chiseled_deepslate": "Pissarra cisellada",
  "block.minecraft.chiseled_nether_bricks": "Maons del Nether cisellats",
  "block.minecraft.chiseled_polished_blackstone": "Roca negra polida cisellada",
  "block.minecraft.chiseled_quartz_block": "Bloc de quars cisellat",
  "block.minecraft.chiseled_red_sandstone": "Roca sorrenca cisellada",
  "block.minecraft.chiseled_resin_bricks": "Maons de resina cisellats",
  "block.minecraft.chiseled_sandstone": "Roca sorrenca cisellada",
  "block.minecraft.chiseled_stone_bricks": "Maons de roca cisellats",
  "block.minecraft.chiseled_tuff": "Tuf cisellat",
  "block.minecraft.chiseled_tuff_bricks": "Maons de tuf cisellats",
  "block.minecraft.chorus_flower": "Flor de tornada",
  "block.minecraft.chorus_plant": "Planta de tornada",
  "block.minecraft.clay": "Argila",
  "block.minecraft.closed_eyeblossom": "Iridàcia tancada",
  "block.minecraft.coal_block": "Bloc de carbó",
  "block.minecraft.coal_ore": "Mena de carbó",
  "block.minecraft.coarse_dirt": "Terra seca",
  "block.minecraft.cobbled_deepslate": "Empedrat de pissarra",
  "block.minecraft.cobbled_deepslate_slab": "Llosa d'empedrat de pissarra",
  "block.minecraft.cobbled_deepslate_stairs": "Escales d'empedrat de pissarra",
  "block.minecraft.cobbled_deepslate_wall": "Mur d'empedrat de pissarra",
  "block.minecraft.cobblestone": "Pedra",
  "block.minecraft.cobblestone_slab": "Llosa de pedra",
  "block.minecraft.cobblestone_stairs": "Escales de pedra",
  "block.minecraft.cobblestone_wall": "Mur de pedra",
  "block.minecraft.cobweb": "Teranyina",
  "block.minecraft.cocoa": "Cacau",
  "block.minecraft.command_block": "Bloc de comandaments",
  "block.minecraft.comparator": "Comparador",
  "block.minecraft.composter": "Compostador",
  "block.minecraft.conduit": "Canalitzador",
  "block.minecraft.copper_bars": "Barres de coure",
  "block.minecraft.copper_block": "Bloc de coure",
  "block.minecraft.copper_bulb": "Bombeta de coure",
  "block.minecraft.copper_chain": "Cadenes de coure",
  "block.minecraft.copper_chest": "Bagul de coure",
  "block.minecraft.copper_door": "Porta de coure",
  "block.minecraft.copper_golem_statue": "Estàtua de Gòlem de Coure",
  "block.minecraft.copper_grate": "Reixa de coure",
  "block.minecraft.copper_lantern": "Fanal de Coure",
  "block.minecraft.copper_ore": "Mena de coure",
  "block.minecraft.copper_torch": "Antorxa de Coure",
  "block.minecraft.copper_trapdoor": "Trapa de coure",
  "block.minecraft.copper_wall_torch": "Antorxa de paret de Coure",
  "block.minecraft.cornflower": "Blavet",
  "block.minecraft.cracked_deepslate_bricks": "Maons de pissarra esquerdats",
  "block.minecraft.cracked_deepslate_tiles": "Rajoles de pissarra esquerdades",
  "block.minecraft.cracked_nether_bricks": "Maons del Nether esquerdats",
  "block.minecraft.cracked_polished_blackstone_bricks": "Maons de roca negra polida esquerdats",
  "block.minecraft.cracked_stone_bricks": "Maons de roca esquerdats",
  "block.minecraft.crafter": "Elaborador",
  "block.minecraft.crafting_table": "Taula d'elaboració",
  "block.minecraft.creaking_heart": "Cor de cruixidor",
  "block.minecraft.creeper_head": "Cap de creeper",
  "block.minecraft.creeper_wall_head": "Cap de creeper a la paret",
  "block.minecraft.crimson_button": "Botó carmesí",
  "block.minecraft.crimson_door": "Porta carmesina",
  "block.minecraft.crimson_fence": "Tanca carmesina",
  "block.minecraft.crimson_fence_gate": "Porta de tanca carmesina",
  "block.minecraft.crimson_fungus": "Fong carmesí",
  "block.minecraft.crimson_hanging_sign": "Cartell penjant carmesí",
  "block.minecraft.crimson_hyphae": "Hifes carmesines",
  "block.minecraft.crimson_nylium": "Netheli carmesí",
  "block.minecraft.crimson_planks": "Fusta carmesina",
  "block.minecraft.crimson_pressure_plate": "Placa de pressió carmesina",
  "block.minecraft.crimson_roots": "Arrels carmesines",
  "block.minecraft.crimson_shelf": "Prestatgeria carmesina",
  "block.minecraft.crimson_sign": "Cartell carmesí",
  "block.minecraft.crimson_slab": "Llosa carmesina",
  "block.minecraft.crimson_stairs": "Escales carmesines",
  "block.minecraft.crimson_stem": "Peu carmesí",
  "block.minecraft.crimson_trapdoor": "Trapa carmesina",
  "block.minecraft.crimson_wall_hanging_sign": "Cartell penjant carmesí amb suport",
  "block.minecraft.crimson_wall_sign": "Cartell carmesí a la paret",
  "block.minecraft.crying_obsidian": "Obsidiana plorosa",
  "block.minecraft.cut_copper": "Coure tallat",
  "block.minecraft.cut_copper_slab": "Llosa de coure tallat",
  "block.minecraft.cut_copper_stairs": "Escales de coure tallat",
  "block.minecraft.cut_red_sandstone": "Roca sorrenca vermella tallada",
  "block.minecraft.cut_red_sandstone_slab": "Llosa de roca sorrenca vermella tallada",
  "block.minecraft.cut_sandstone": "Roca sorrenca tallada",
  "block.minecraft.cut_sandstone_slab": "Llosa de roca sorrenca tallada",
  "block.minecraft.cyan_banner": "Estendard cian",
  "block.minecraft.cyan_bed": "Llit cian",
  "block.minecraft.cyan_candle": "Espelma cian",
  "block.minecraft.cyan_candle_cake": "Pastís amb espelma cian",
  "block.minecraft.cyan_carpet": "Catifa cian",
  "block.minecraft.cyan_concrete": "Formigó cian",
  "block.minecraft.cyan_concrete_powder": "Pols de formigó cian",
  "block.minecraft.cyan_glazed_terracotta": "Rajola cian",
  "block.minecraft.cyan_shulker_box": "Caixa de shulker cian",
  "block.minecraft.cyan_stained_glass": "Vidre tenyit de cian",
  "block.minecraft.cyan_stained_glass_pane": "Panell de vidre tenyit de cian",
  "block.minecraft.cyan_terracotta": "Terracota cian",
  "block.minecraft.cyan_wool": "Llana cian",
  "block.minecraft.damaged_anvil": "Enclusa molt danyada",
  "block.minecraft.dandelion": "Dent de lleó",
  "block.minecraft.dark_oak_button": "Botó de pomer fosc",
  "block.minecraft.dark_oak_door": "Porta de pomer fosc",
  "block.minecraft.dark_oak_fence": "Tanca de pomer fosc",
  "block.minecraft.dark_oak_fence_gate": "Porta de tanca de pomer fosc",
  "block.minecraft.dark_oak_hanging_sign": "Cartell penjant de pomer fosc",
  "block.minecraft.dark_oak_leaves": "Fulles de pomer fosc",
  "block.minecraft.dark_oak_log": "Tronc de pomer fosc",
  "block.minecraft.dark_oak_planks": "Fusta de pomer fosc",
  "block.minecraft.dark_oak_pressure_plate": "Placa de pressió de pomer fosc",
  "block.minecraft.dark_oak_sapling": "Esqueix de pomer fosc",
  "block.minecraft.dark_oak_shelf": "Prestatgeria de roure fosc",
  "block.minecraft.dark_oak_sign": "Cartell de pomer fosc",
  "block.minecraft.dark_oak_slab": "Llosa de pomer fosc",
  "block.minecraft.dark_oak_stairs": "Escales de pomer fosc",
  "block.minecraft.dark_oak_trapdoor": "Trapa de pomer fosc",
  "block.minecraft.dark_oak_wall_hanging_sign": "Cartell penjant de pomer fosc amb suport",
  "block.minecraft.dark_oak_wall_sign": "Cartell de pomer fosc a la paret",
  "block.minecraft.dark_oak_wood": "Fusta de pomer fosc",
  "block.minecraft.dark_prismarine": "Prismarina fosca",
  "block.minecraft.dark_prismarine_slab": "Llosa de prismarina fosca",
  "block.minecraft.dark_prismarine_stairs": "Escales de prismarina fosca",
  "block.minecraft.daylight_detector": "Sensor de llum solar",
  "block.minecraft.dead_brain_coral": "Corall de cervell mort",
  "block.minecraft.dead_brain_coral_block": "Bloc de corall de cervell mort",
  "block.minecraft.dead_brain_coral_fan": "Gorgònia de cervell morta",
  "block.minecraft.dead_brain_coral_wall_fan": "Gorgònia de cervell morta a la paret",
  "block.minecraft.dead_bubble_coral": "Corall de bombolla mort",
  "block.minecraft.dead_bubble_coral_block": "Bloc de corall de bombolla mort",
  "block.minecraft.dead_bubble_coral_fan": "Gorgònia de bombolla morta",
  "block.minecraft.dead_bubble_coral_wall_fan": "Gorgònia de bombolla morta a la paret",
  "block.minecraft.dead_bush": "Arbust mort",
  "block.minecraft.dead_fire_coral": "Corall de foc mort",
  "block.minecraft.dead_fire_coral_block": "Bloc de corall de foc mort",
  "block.minecraft.dead_fire_coral_fan": "Gorgònia de foc morta",
  "block.minecraft.dead_fire_coral_wall_fan": "Gorgònia de foc morta a la paret",
  "block.minecraft.dead_horn_coral": "Corall de banya mort",
  "block.minecraft.dead_horn_coral_block": "Bloc de corall de banya mort",
  "block.minecraft.dead_horn_coral_fan": "Gorgònia de banya morta",
  "block.minecraft.dead_horn_coral_wall_fan": "Gorgònia de banya morta a la paret",
  "block.minecraft.dead_tube_coral": "Corall de tub mort",
  "block.minecraft.dead_tube_coral_block": "Bloc de corall de tub mort",
  "block.minecraft.dead_tube_coral_fan": "Gorgònia de tub morta",
  "block.minecraft.dead_tube_coral_wall_fan": "Gorgònia de tub morta a la paret",
  "block.minecraft.decorated_pot": "Gerro decorat",
  "block.minecraft.deepslate": "Pissarra",
  "block.minecraft.deepslate_brick_slab": "Llosa de maons de pissarra",
  "block.minecraft.deepslate_brick_stairs": "Escales de maons de pissarra",
  "block.minecraft.deepslate_brick_wall": "Mur de maons de pissarra",
  "block.minecraft.deepslate_bricks": "Maons de pissarra",
  "block.minecraft.deepslate_coal_ore": "Mena de carbó en pissarra",
  "block.minecraft.deepslate_copper_ore": "Mena de coure en pissarra",
  "block.minecraft.deepslate_diamond_ore": "Mena de diamant en pissarra",
  "block.minecraft.deepslate_emerald_ore": "Mena de maragda en pissarra",
  "block.minecraft.deepslate_gold_ore": "Mena d'or en pissarra",
  "block.minecraft.deepslate_iron_ore": "Mena de ferro en pissarra",
  "block.minecraft.deepslate_lapis_ore": "Mena de lapislàtzuli en pissarra",
  "block.minecraft.deepslate_redstone_ore": "Mena de redstone en pissarra",
  "block.minecraft.deepslate_tile_slab": "Llosa de rajoles de pissarra",
  "block.minecraft.deepslate_tile_stairs": "Escales de rajoles de pissarra",
  "block.minecraft.deepslate_tile_wall": "Mur d'enrajolat de pissarra",
  "block.minecraft.deepslate_tiles": "Rajoles de pissarra",
  "block.minecraft.detector_rail": "Rail detector",
  "block.minecraft.diamond_block": "Bloc de diamant",
  "block.minecraft.diamond_ore": "Mena de diamant",
  "block.minecraft.diorite": "Diorita",
  "block.minecraft.diorite_slab": "Llosa de diorita",
  "block.minecraft.diorite_stairs": "Escales de diorita",
  "block.minecraft.diorite_wall": "Mur de diorita",
  "block.minecraft.dirt": "Terra",
  "block.minecraft.dirt_path": "Camí de terra",
  "block.minecraft.dispenser": "Dispensador",
  "block.minecraft.dragon_egg": "Ou de drac",
  "block.minecraft.dragon_head": "Cap de drac",
  "block.minecraft.dragon_wall_head": "Cap de drac a la paret",
  "block.minecraft.dried_ghast": "Ghast Sec",
  "block.minecraft.dried_kelp_block": "Bloc d'algues seques",
  "block.minecraft.dripstone_block": "Bloc d'espeleotema",
  "block.minecraft.dropper": "Subministrador",
  "block.minecraft.emerald_block": "Bloc de maragda",
  "block.minecraft.emerald_ore": "Mena de maragda",
  "block.minecraft.enchanting_table": "Taula d'encanteris",
  "block.minecraft.end_gateway": "Entrada de l'End",
  "block.minecraft.end_portal": "Portal de l'End",
  "block.minecraft.end_portal_frame": "Marc del portal de l'End",
  "block.minecraft.end_rod": "Vara de l'End",
  "block.minecraft.end_stone": "Roca de l'End",
  "block.minecraft.end_stone_brick_slab": "Llosa de maons de roca de l'End",
  "block.minecraft.end_stone_brick_stairs": "Escales de maons de roca de l'End",
  "block.minecraft.end_stone_brick_wall": "Mur de maons de roca de l'End",
  "block.minecraft.end_stone_bricks": "Maons de roca de l'End",
  "block.minecraft.ender_chest": "Cofre d'Ender",
  "block.minecraft.exposed_chiseled_copper": "Coure exposat cisellat",
  "block.minecraft.exposed_copper": "Coure exposat",
  "block.minecraft.exposed_copper_bars": "Barrots de coure exposat",
  "block.minecraft.exposed_copper_bulb": "Bombeta de coure exposat",
  "block.minecraft.exposed_copper_chain": "Cadena de coure exposat",
  "block.minecraft.exposed_copper_chest": "Cofre de coure exposat",
  "block.minecraft.exposed_copper_door": "Porta de coure exposat",
  "block.minecraft.exposed_copper_golem_statue": "Estàtua de gòlem de coure exposat",
  "block.minecraft.exposed_copper_grate": "Reixa de coure exposat",
  "block.minecraft.exposed_copper_lantern": "Fanal de coure exposat",
  "block.minecraft.exposed_copper_trapdoor": "Trapa de coure exposat",
  "block.minecraft.exposed_cut_copper": "Coure tallat exposat",
  "block.minecraft.exposed_cut_copper_slab": "Llosa de coure tallat exposada",
  "block.minecraft.exposed_cut_copper_stairs": "Escales de coure tallat exposades",
  "block.minecraft.exposed_lightning_rod": "Parallamps exposat",
  "block.minecraft.farmland": "Terra de cultiu",
  "block.minecraft.fern": "Falguera",
  "block.minecraft.fire": "Foc",
  "block.minecraft.fire_coral": "Corall de foc",
  "block.minecraft.fire_coral_block": "Bloc de corall de foc",
  "block.minecraft.fire_coral_fan": "Gorgònia de foc",
  "block.minecraft.fire_coral_wall_fan": "Gorgònia de foc a la paret",
  "block.minecraft.firefly_bush": "Matoll de cuques de llum",
  "block.minecraft.fletching_table": "Taula de fletxes",
  "block.minecraft.flower_pot": "Test",
  "block.minecraft.flowering_azalea": "Azalea florida",
  "block.minecraft.flowering_azalea_leaves": "Fulles d'azalea florida",
  "block.minecraft.frogspawn": "Ous de granota",
  "block.minecraft.frosted_ice": "Gel glaçat",
  "block.minecraft.furnace": "Forn",
  "block.minecraft.gilded_blackstone": "Roca negra lluent",
  "block.minecraft.glass": "Vidre",
  "block.minecraft.glass_pane": "Panell de vidre",
  "block.minecraft.glow_lichen": "Liquen lluent",
  "block.minecraft.glowstone": "Roca brillant",
  "block.minecraft.gold_block": "Bloc d'or",
  "block.minecraft.gold_ore": "Mena d'or",
  "block.minecraft.golden_dandelion": "Dent de lleó daurat",
  "block.minecraft.granite": "Granit",
  "block.minecraft.granite_slab": "Llosa de granit",
  "block.minecraft.granite_stairs": "Escales de granit",
  "block.minecraft.granite_wall": "Mur de granit",
  "block.minecraft.grass": "Herba",
  "block.minecraft.grass_block": "Bloc d'herba",
  "block.minecraft.gravel": "Grava",
  "block.minecraft.gray_banner": "Estendard gris",
  "block.minecraft.gray_bed": "Llit gris",
  "block.minecraft.gray_candle": "Espelma grisa",
  "block.minecraft.gray_candle_cake": "Pastís amb espelma grisa",
  "block.minecraft.gray_carpet": "Catifa grisa",
  "block.minecraft.gray_concrete": "Formigó gris",
  "block.minecraft.gray_concrete_powder": "Pols de formigó gris",
  "block.minecraft.gray_glazed_terracotta": "Rajola gris",
  "block.minecraft.gray_shulker_box": "Caixa de shulker grisa",
  "block.minecraft.gray_stained_glass": "Vidre tenyit de gris",
  "block.minecraft.gray_stained_glass_pane": "Panell de vidre tenyit de gris",
  "block.minecraft.gray_terracotta": "Terracota grisa",
  "block.minecraft.gray_wool": "Llana grisa",
  "block.minecraft.green_banner": "Estendard de sinople",
  "block.minecraft.green_bed": "Llit verd",
  "block.minecraft.green_candle": "Espelma verda",
  "block.minecraft.green_candle_cake": "Pastís amb espelma verda",
  "block.minecraft.green_carpet": "Catifa verda",
  "block.minecraft.green_concrete": "Formigó verd",
  "block.minecraft.green_concrete_powder": "Pols de formigó verd",
  "block.minecraft.green_glazed_terracotta": "Rajola verda",
  "block.minecraft.green_shulker_box": "Caixa de shulker verda",
  "block.minecraft.green_stained_glass": "Vidre tenyit de verd",
  "block.minecraft.green_stained_glass_pane": "Panell de vidre tenyit de verd",
  "block.minecraft.green_terracotta": "Terracota verda",
  "block.minecraft.green_wool": "Llana verda",
  "block.minecraft.grindstone": "Afiladora",
  "block.minecraft.hanging_roots": "Arrels penjants",
  "block.minecraft.hay_block": "Bala de fenc",
  "block.minecraft.heavy_core": "Nucli dens",
  "block.minecraft.heavy_weighted_pressure_plate": "Placa de pressió per a pes elevat",
  "block.minecraft.honey_block": "Bloc de mel",
  "block.minecraft.honeycomb_block": "Bloc de bresca",
  "block.minecraft.hopper": "Tremuja",
  "block.minecraft.horn_coral": "Corall de banya",
  "block.minecraft.horn_coral_block": "Bloc de corall de banya",
  "block.minecraft.horn_coral_fan": "Gorgònia de banya",
  "block.minecraft.horn_coral_wall_fan": "Gorgònia de banya a la paret",
  "block.minecraft.ice": "Gel",
  "block.minecraft.infested_chiseled_stone_bricks": "Maons de roca cisellats infestats",
  "block.minecraft.infested_cobblestone": "Pedra infestada",
  "block.minecraft.infested_cracked_stone_bricks": "Maons de roca esquerdats infestats",
  "block.minecraft.infested_deepslate": "Pissarra infestada",
  "block.minecraft.infested_mossy_stone_bricks": "Maons de roca amb molsa infestats",
  "block.minecraft.infested_stone": "Roca infestada",
  "block.minecraft.infested_stone_bricks": "Maons de roca infestats",
  "block.minecraft.iron_bars": "Barrots de ferro",
  "block.minecraft.iron_block": "Bloc de ferro",
  "block.minecraft.iron_chain": "Cadena de ferro",
  "block.minecraft.iron_door": "Porta de ferro",
  "block.minecraft.iron_ore": "Mena de ferro",
  "block.minecraft.iron_trapdoor": "Trapa de ferro",
  "block.minecraft.jack_o_lantern": "Carbassa de Halloween",
  "block.minecraft.jigsaw": "Bloc trencaclosques",
  "block.minecraft.jukebox": "Tocadiscs",
  "block.minecraft.jungle_button": "Botó de jungla",
  "block.minecraft.jungle_door": "Porta de jungla",
  "block.minecraft.jungle_fence": "Tanca de jungla",
  "block.minecraft.jungle_fence_gate": "Porta de tanca de jungla",
  "block.minecraft.jungle_hanging_sign": "Cartell penjant de jungla",
  "block.minecraft.jungle_leaves": "Fulles de jungla",
  "block.minecraft.jungle_log": "Tronc de jungla",
  "block.minecraft.jungle_planks": "Fusta de jungla",
  "block.minecraft.jungle_pressure_plate": "Placa de pressió de jungla",
  "block.minecraft.jungle_sapling": "Esqueix de jungla",
  "block.minecraft.jungle_shelf": "Prestatge de jungla",
  "block.minecraft.jungle_sign": "Cartell de jungla",
  "block.minecraft.jungle_slab": "Llosa de jungla",
  "block.minecraft.jungle_stairs": "Escales de jungla",
  "block.minecraft.jungle_trapdoor": "Trapa de jungla",
  "block.minecraft.jungle_wall_hanging_sign": "Cartell penjant de jungla amb suport",
  "block.minecraft.jungle_wall_sign": "Cartell de jungla a la paret",
  "block.minecraft.jungle_wood": "Fusta de jungla",
  "block.minecraft.kelp": "Alga",
  "block.minecraft.kelp_plant": "Tija d'alga",
  "block.minecraft.ladder": "Escala",
  "block.minecraft.lantern": "Fanal",
  "block.minecraft.lapis_block": "Bloc de lapislàtzuli",
  "block.minecraft.lapis_ore": "Mena de lapislàtzuli",
  "block.minecraft.large_amethyst_bud": "Cristall d'ametista gran",
  "block.minecraft.large_fern": "Falguera gran",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Calderó amb lava",
  "block.minecraft.leaf_litter": "Fulles seques",
  "block.minecraft.lectern": "Faristol",
  "block.minecraft.lever": "Palanca",
  "block.minecraft.light": "Llum",
  "block.minecraft.light_blue_banner": "Estendard blau cel",
  "block.minecraft.light_blue_bed": "Llit blau cel",
  "block.minecraft.light_blue_candle": "Espelma blau cel",
  "block.minecraft.light_blue_candle_cake": "Pastís amb espelma blau cel",
  "block.minecraft.light_blue_carpet": "Catifa blau cel",
  "block.minecraft.light_blue_concrete": "Formigó blau cel",
  "block.minecraft.light_blue_concrete_powder": "Pols de formigó blau cel",
  "block.minecraft.light_blue_glazed_terracotta": "Rajola blau cel",
  "block.minecraft.light_blue_shulker_box": "Caixa de shulker blau cel",
  "block.minecraft.light_blue_stained_glass": "Vidre tenyit de blau cel",
  "block.minecraft.light_blue_stained_glass_pane": "Panell de vidre tenyit de blau cel",
  "block.minecraft.light_blue_terracotta": "Terracota blau cel",
  "block.minecraft.light_blue_wool": "Llana blau cel",
  "block.minecraft.light_gray_banner": "Estendard d'argent",
  "block.minecraft.light_gray_bed": "Llit gris clar",
  "block.minecraft.light_gray_candle": "Espelma gris clar",
  "block.minecraft.light_gray_candle_cake": "Pastís amb espelma gris clar",
  "block.minecraft.light_gray_carpet": "Catifa gris clar",
  "block.minecraft.light_gray_concrete": "Formigó gris clar",
  "block.minecraft.light_gray_concrete_powder": "Pols de formigó gris clar",
  "block.minecraft.light_gray_glazed_terracotta": "Rajola gris clar",
  "block.minecraft.light_gray_shulker_box": "Caixa de shulker gris clar",
  "block.minecraft.light_gray_stained_glass": "Vidre tenyit de gris clar",
  "block.minecraft.light_gray_stained_glass_pane": "Panell de vidre tenyit de gris clar",
  "block.minecraft.light_gray_terracotta": "Terracota gris clar",
  "block.minecraft.light_gray_wool": "Llana gris clar",
  "block.minecraft.light_weighted_pressure_plate": "Placa de pressió per a pes lleuger",
  "block.minecraft.lightning_rod": "Parallamps",
  "block.minecraft.lilac": "Lilà",
  "block.minecraft.lily_of_the_valley": "Lliri de maig",
  "block.minecraft.lily_pad": "Nenúfar",
  "block.minecraft.lime_banner": "Estendard llima",
  "block.minecraft.lime_bed": "Llit llima",
  "block.minecraft.lime_candle": "Espelma llima",
  "block.minecraft.lime_candle_cake": "Pastís amb espelma llima",
  "block.minecraft.lime_carpet": "Catifa llima",
  "block.minecraft.lime_concrete": "Formigó llima",
  "block.minecraft.lime_concrete_powder": "Pols de formigó llima",
  "block.minecraft.lime_glazed_terracotta": "Rajola llima",
  "block.minecraft.lime_shulker_box": "Caixa de shulker llima",
  "block.minecraft.lime_stained_glass": "Vidre tenyit de llima",
  "block.minecraft.lime_stained_glass_pane": "Panell de vidre tenyit de llima",
  "block.minecraft.lime_terracotta": "Terracota verd llima",
  "block.minecraft.lime_wool": "Llana llima",
  "block.minecraft.lodestone": "Fita",
  "block.minecraft.loom": "Teler",
  "block.minecraft.magenta_banner": "Estendard magenta",
  "block.minecraft.magenta_bed": "Llit magenta",
  "block.minecraft.magenta_candle": "Espelma magenta",
  "block.minecraft.magenta_candle_cake": "Pastís amb espelma magenta",
  "block.minecraft.magenta_carpet": "Catifa magenta",
  "block.minecraft.magenta_concrete": "Formigó magenta",
  "block.minecraft.magenta_concrete_powder": "Pols de formigó magenta",
  "block.minecraft.magenta_glazed_terracotta": "Rajola magenta",
  "block.minecraft.magenta_shulker_box": "Caixa de shulker magenta",
  "block.minecraft.magenta_stained_glass": "Vidre tenyit de magenta",
  "block.minecraft.magenta_stained_glass_pane": "Panell de vidre tenyit de magenta",
  "block.minecraft.magenta_terracotta": "Terracota magenta",
  "block.minecraft.magenta_wool": "Llana magenta",
  "block.minecraft.magma_block": "Bloc de magma",
  "block.minecraft.mangrove_button": "Botó de mangle",
  "block.minecraft.mangrove_door": "Porta de mangle",
  "block.minecraft.mangrove_fence": "Tanca de mangle",
  "block.minecraft.mangrove_fence_gate": "Porta de tanca de mangle",
  "block.minecraft.mangrove_hanging_sign": "Cartell penjant de mangle",
  "block.minecraft.mangrove_leaves": "Fulles de mangle",
  "block.minecraft.mangrove_log": "Tronc de mangle",
  "block.minecraft.mangrove_planks": "Fusta de mangle",
  "block.minecraft.mangrove_pressure_plate": "Placa de pressió de mangle",
  "block.minecraft.mangrove_propagule": "Propàgul de mangle",
  "block.minecraft.mangrove_roots": "Arrels de mangle",
  "block.minecraft.mangrove_shelf": "Prestatge de mangle",
  "block.minecraft.mangrove_sign": "Cartell de mangle",
  "block.minecraft.mangrove_slab": "Llosa de mangle",
  "block.minecraft.mangrove_stairs": "Escales de mangle",
  "block.minecraft.mangrove_trapdoor": "Trapa de mangle",
  "block.minecraft.mangrove_wall_hanging_sign": "Cartell penjant de mangle amb suport",
  "block.minecraft.mangrove_wall_sign": "Cartell de mangle a la paret",
  "block.minecraft.mangrove_wood": "Fusta de mangle",
  "block.minecraft.medium_amethyst_bud": "Cristall d'ametista mitjà",
  "block.minecraft.melon": "Síndria",
  "block.minecraft.melon_stem": "Tija de síndria",
  "block.minecraft.moss_block": "Bloc de molsa",
  "block.minecraft.moss_carpet": "Catifa de molsa",
  "block.minecraft.mossy_cobblestone": "Pedra amb molsa",
  "block.minecraft.mossy_cobblestone_slab": "Llosa de pedra amb molsa",
  "block.minecraft.mossy_cobblestone_stairs": "Escales de pedra amb molsa",
  "block.minecraft.mossy_cobblestone_wall": "Mur de pedra amb molsa",
  "block.minecraft.mossy_stone_brick_slab": "Llosa de maons de roca amb molsa",
  "block.minecraft.mossy_stone_brick_stairs": "Escales de maons de roca amb molsa",
  "block.minecraft.mossy_stone_brick_wall": "Mur de maons de roca amb molsa",
  "block.minecraft.mossy_stone_bricks": "Maons de roca amb molsa",
  "block.minecraft.moving_piston": "Pistó en moviment",
  "block.minecraft.mud": "Fang",
  "block.minecraft.mud_brick_slab": "Llosa de tova",
  "block.minecraft.mud_brick_stairs": "Escales de tova",
  "block.minecraft.mud_brick_wall": "Mur de tova",
  "block.minecraft.mud_bricks": "Tova",
  "block.minecraft.muddy_mangrove_roots": "Arrels de mangle enfangades",
  "block.minecraft.mushroom_stem": "Peu de bolet",
  "block.minecraft.mycelium": "Miceli",
  "block.minecraft.nether_brick_fence": "Tanca de maó del Nether",
  "block.minecraft.nether_brick_slab": "Llosa de maons del Nether",
  "block.minecraft.nether_brick_stairs": "Escales de maons del Nether",
  "block.minecraft.nether_brick_wall": "Mur de maons del Nether",
  "block.minecraft.nether_bricks": "Maons del Nether",
  "block.minecraft.nether_gold_ore": "Mena d'or del Nether",
  "block.minecraft.nether_portal": "Portal del Nether",
  "block.minecraft.nether_quartz_ore": "Mena de quars del Nether",
  "block.minecraft.nether_sprouts": "Brots del Nether",
  "block.minecraft.nether_wart": "Berruga del Nether",
  "block.minecraft.nether_wart_block": "Bloc de berrugues del Nether",
  "block.minecraft.netherite_block": "Bloc de netherita",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Bloc musical",
  "block.minecraft.oak_button": "Botó de pomer",
  "block.minecraft.oak_door": "Porta de pomer",
  "block.minecraft.oak_fence": "Tanca de pomer",
  "block.minecraft.oak_fence_gate": "Porta de tanca de pomer",
  "block.minecraft.oak_hanging_sign": "Cartell penjant de pomer",
  "block.minecraft.oak_leaves": "Fulles de pomer",
  "block.minecraft.oak_log": "Tronc de pomer",
  "block.minecraft.oak_planks": "Fusta de pomer",
  "block.minecraft.oak_pressure_plate": "Placa de pressió de pomer",
  "block.minecraft.oak_sapling": "Esqueix de pomer",
  "block.minecraft.oak_shelf": "Prestatge de roure",
  "block.minecraft.oak_sign": "Cartell de pomer",
  "block.minecraft.oak_slab": "Llosa de pomer",
  "block.minecraft.oak_stairs": "Escales de pomer",
  "block.minecraft.oak_trapdoor": "Trapa de pomer",
  "block.minecraft.oak_wall_hanging_sign": "Cartell penjant de pomer amb suport",
  "block.minecraft.oak_wall_sign": "Cartell de pomer a la paret",
  "block.minecraft.oak_wood": "Fusta de pomer",
  "block.minecraft.observer": "Observador",
  "block.minecraft.obsidian": "Obsidiana",
  "block.minecraft.ochre_froglight": "Granollum ocre",
  "block.minecraft.ominous_banner": "Estendard ominós",
  "block.minecraft.open_eyeblossom": "Iridàcia oberta",
  "block.minecraft.orange_banner": "Estendard ataronjat",
  "block.minecraft.orange_bed": "Llit taronja",
  "block.minecraft.orange_candle": "Espelma taronja",
  "block.minecraft.orange_candle_cake": "Pastís amb espelma taronja",
  "block.minecraft.orange_carpet": "Catifa taronja",
  "block.minecraft.orange_concrete": "Formigó taronja",
  "block.minecraft.orange_concrete_powder": "Pols de formigó taronja",
  "block.minecraft.orange_glazed_terracotta": "Rajola taronja",
  "block.minecraft.orange_shulker_box": "Caixa de shulker taronja",
  "block.minecraft.orange_stained_glass": "Vidre tenyit de taronja",
  "block.minecraft.orange_stained_glass_pane": "Panell de vidre tenyit de taronja",
  "block.minecraft.orange_terracotta": "Terracota taronja",
  "block.minecraft.orange_tulip": "Tulipa taronja",
  "block.minecraft.orange_wool": "Llana taronja",
  "block.minecraft.oxeye_daisy": "Margarida",
  "block.minecraft.oxidized_chiseled_copper": "Coure oxidat cisellat",
  "block.minecraft.oxidized_copper": "Coure oxidat",
  "block.minecraft.oxidized_copper_bars": "Barrots de coure oxidat",
  "block.minecraft.oxidized_copper_bulb": "Bombeta de coure oxidat",
  "block.minecraft.oxidized_copper_chain": "Cadena de coure oxidat",
  "block.minecraft.oxidized_copper_chest": "Cofre de coure oxidat",
  "block.minecraft.oxidized_copper_door": "Porta de coure oxidat",
  "block.minecraft.oxidized_copper_golem_statue": "Estàtua de gòlem de coure oxidat",
  "block.minecraft.oxidized_copper_grate": "Reixa de coure oxidat",
  "block.minecraft.oxidized_copper_lantern": "Fanal de coure oxidat",
  "block.minecraft.oxidized_copper_trapdoor": "Trapa de coure oxidat",
  "block.minecraft.oxidized_cut_copper": "Coure tallat oxidat",
  "block.minecraft.oxidized_cut_copper_slab": "Llosa de coure tallat oxidada",
  "block.minecraft.oxidized_cut_copper_stairs": "Escales de coure tallat oxidades",
  "block.minecraft.oxidized_lightning_rod": "Parallamps oxidat",
  "block.minecraft.packed_ice": "Gel compactat",
  "block.minecraft.packed_mud": "Fang compactat",
  "block.minecraft.pale_hanging_moss": "Molsa pàl·lida penjant",
  "block.minecraft.pale_moss_block": "Bloc de molsa pàl·lida",
  "block.minecraft.pale_moss_carpet": "Catifa de molsa pàl·lida",
  "block.minecraft.pale_oak_button": "Botó de roure pàl·lid",
  "block.minecraft.pale_oak_door": "Porta de roure pàl·lid",
  "block.minecraft.pale_oak_fence": "Tanca de roure pàl·lid",
  "block.minecraft.pale_oak_fence_gate": "Porta de tanca de roure pàl·lid",
  "block.minecraft.pale_oak_hanging_sign": "Rètol de paret de roure pàl·lid",
  "block.minecraft.pale_oak_leaves": "Fulles de roure pàl·lid",
  "block.minecraft.pale_oak_log": "Tronc de roure pàl·lid",
  "block.minecraft.pale_oak_planks": "Taulons de fusta de roure pàl·lid",
  "block.minecraft.pale_oak_pressure_plate": "Placa de pressió de roure pàl·lid",
  "block.minecraft.pale_oak_sapling": "Esqueix de roure pàl·lid",
  "block.minecraft.pale_oak_shelf": "Prestatge de roure pàl·lid",
  "block.minecraft.pale_oak_sign": "Rètol de roure pàl·lid",
  "block.minecraft.pale_oak_slab": "Llosa de roure pàl·lid",
  "block.minecraft.pale_oak_stairs": "Escales de roure pàl·lid",
  "block.minecraft.pale_oak_trapdoor": "Trapa de roure pàl·lid",
  "block.minecraft.pale_oak_wall_hanging_sign": "Cartell penjant de roure pàl·lid amb suport",
  "block.minecraft.pale_oak_wall_sign": "Cartell de roure pàl·lid",
  "block.minecraft.pale_oak_wood": "Fusta de roure pàl·lid",
  "block.minecraft.pearlescent_froglight": "Granollum nacrada",
  "block.minecraft.peony": "Peònia",
  "block.minecraft.petrified_oak_slab": "Llosa de pomer petrificada",
  "block.minecraft.piglin_head": "Cap de piglin",
  "block.minecraft.piglin_wall_head": "Cap de piglin a la paret",
  "block.minecraft.pink_banner": "Estendard rosa",
  "block.minecraft.pink_bed": "Llit rosa",
  "block.minecraft.pink_candle": "Espelma rosa",
  "block.minecraft.pink_candle_cake": "Pastís amb espelma rosa",
  "block.minecraft.pink_carpet": "Catifa rosa",
  "block.minecraft.pink_concrete": "Formigó rosa",
  "block.minecraft.pink_concrete_powder": "Pols de formigó rosa",
  "block.minecraft.pink_glazed_terracotta": "Rajola rosa",
  "block.minecraft.pink_petals": "Pètals rosa",
  "block.minecraft.pink_shulker_box": "Caixa de shulker rosa",
  "block.minecraft.pink_stained_glass": "Vidre tenyit de rosa",
  "block.minecraft.pink_stained_glass_pane": "Panell de vidre tenyit de rosa",
  "block.minecraft.pink_terracotta": "Terracota rosa",
  "block.minecraft.pink_tulip": "Tulipa rosa",
  "block.minecraft.pink_wool": "Llana rosa",
  "block.minecraft.piston": "Pistó",
  "block.minecraft.piston_head": "Cap de pistó",
  "block.minecraft.pitcher_crop": "Cultiu de planta gerro",
  "block.minecraft.pitcher_plant": "Planta gerro",
  "block.minecraft.player_head": "Cap de jugador",
  "block.minecraft.player_head.named": "Cap de %s",
  "block.minecraft.player_wall_head": "Cap de jugador a la paret",
  "block.minecraft.podzol": "Pinassa",
  "block.minecraft.pointed_dripstone": "Espeleotema punxegut",
  "block.minecraft.polished_andesite": "Andesita polida",
  "block.minecraft.polished_andesite_slab": "Llosa d'andesita polida",
  "block.minecraft.polished_andesite_stairs": "Escales d'andesita polida",
  "block.minecraft.polished_basalt": "Basalt polit",
  "block.minecraft.polished_blackstone": "Roca negra polida",
  "block.minecraft.polished_blackstone_brick_slab": "Llosa de maons de roca negra polida",
  "block.minecraft.polished_blackstone_brick_stairs": "Escales de maons de roca negra polida",
  "block.minecraft.polished_blackstone_brick_wall": "Mur de maons de roca negra polida",
  "block.minecraft.polished_blackstone_bricks": "Maons de roca negra polida",
  "block.minecraft.polished_blackstone_button": "Botó de roca negra polida",
  "block.minecraft.polished_blackstone_pressure_plate": "Placa de pressió de roca negra polida",
  "block.minecraft.polished_blackstone_slab": "Llosa de roca negra polida",
  "block.minecraft.polished_blackstone_stairs": "Escales de roca negra polida",
  "block.minecraft.polished_blackstone_wall": "Mur de roca negra polida",
  "block.minecraft.polished_deepslate": "Pissarra polida",
  "block.minecraft.polished_deepslate_slab": "Llosa de pissarra polida",
  "block.minecraft.polished_deepslate_stairs": "Escales de pissarra polida",
  "block.minecraft.polished_deepslate_wall": "Mur de pissarra polida",
  "block.minecraft.polished_diorite": "Diorita polida",
  "block.minecraft.polished_diorite_slab": "Llosa de diorita polida",
  "block.minecraft.polished_diorite_stairs": "Escales de diorita polida",
  "block.minecraft.polished_granite": "Granit polit",
  "block.minecraft.polished_granite_slab": "Llosa de granit polit",
  "block.minecraft.polished_granite_stairs": "Escales de granit polit",
  "block.minecraft.polished_tuff": "Tuf polit",
  "block.minecraft.polished_tuff_slab": "Llosa de tuf polit",
  "block.minecraft.polished_tuff_stairs": "Escales de tuf polit",
  "block.minecraft.polished_tuff_wall": "Mur de tuf polit",
  "block.minecraft.poppy": "Rosella",
  "block.minecraft.potatoes": "Patates",
  "block.minecraft.potted_acacia_sapling": "Test amb esqueix d'acàcia",
  "block.minecraft.potted_allium": "Test amb allium",
  "block.minecraft.potted_azalea_bush": "Test amb azalea",
  "block.minecraft.potted_azure_bluet": "Test amb azure bluet",
  "block.minecraft.potted_bamboo": "Test amb bambú",
  "block.minecraft.potted_birch_sapling": "Test amb esqueix de bedoll",
  "block.minecraft.potted_blue_orchid": "Test amb orquídia blava",
  "block.minecraft.potted_brown_mushroom": "Test amb bolet marró",
  "block.minecraft.potted_cactus": "Test amb cactus",
  "block.minecraft.potted_cherry_sapling": "Test amb esqueix de cirerer",
  "block.minecraft.potted_closed_eyeblossom": "Test amb iridàcia tancada",
  "block.minecraft.potted_cornflower": "Test amb blavet",
  "block.minecraft.potted_crimson_fungus": "Test amb fong carmesí",
  "block.minecraft.potted_crimson_roots": "Test amb arrels carmesines",
  "block.minecraft.potted_dandelion": "Test amb dent de lleó",
  "block.minecraft.potted_dark_oak_sapling": "Test amb esqueix de pomer fosc",
  "block.minecraft.potted_dead_bush": "Test amb arbust sec",
  "block.minecraft.potted_fern": "Test amb falguera",
  "block.minecraft.potted_flowering_azalea_bush": "Test amb azalea florida",
  "block.minecraft.potted_golden_dandelion": "Test amb dent de lleó daurat",
  "block.minecraft.potted_jungle_sapling": "Test amb esqueix de jungla",
  "block.minecraft.potted_lily_of_the_valley": "Test amb lliri de maig",
  "block.minecraft.potted_mangrove_propagule": "Test amb propàgul de mangle",
  "block.minecraft.potted_oak_sapling": "Test amb esqueix de pomer",
  "block.minecraft.potted_open_eyeblossom": "Test amb iridàcia oberta",
  "block.minecraft.potted_orange_tulip": "Test amb tulipà taronja",
  "block.minecraft.potted_oxeye_daisy": "Test amb margarida",
  "block.minecraft.potted_pale_oak_sapling": "Test amb esqueix de roure pàl·lid",
  "block.minecraft.potted_pink_tulip": "Test amb tulipà rosa",
  "block.minecraft.potted_poppy": "Test amb rosella",
  "block.minecraft.potted_red_mushroom": "Test amb bolet vermell",
  "block.minecraft.potted_red_tulip": "Test amb tulipà vermell",
  "block.minecraft.potted_spruce_sapling": "Test amb esqueix de pi",
  "block.minecraft.potted_torchflower": "Test amb florxa",
  "block.minecraft.potted_warped_fungus": "Test amb fong guerxo",
  "block.minecraft.potted_warped_roots": "Test amb arrels guerxes",
  "block.minecraft.potted_white_tulip": "Test amb tulipà blanc",
  "block.minecraft.potted_wither_rose": "Test amb rosa de wither",
  "block.minecraft.powder_snow": "Neu pols",
  "block.minecraft.powder_snow_cauldron": "Calderó amb neu pols",
  "block.minecraft.powered_rail": "Rail propulsor",
  "block.minecraft.prismarine": "Prismarina",
  "block.minecraft.prismarine_brick_slab": "Llosa de maons de prismarina",
  "block.minecraft.prismarine_brick_stairs": "Escales de maons de prismarina",
  "block.minecraft.prismarine_bricks": "Maons de prismarina",
  "block.minecraft.prismarine_slab": "Llosa de prismarina",
  "block.minecraft.prismarine_stairs": "Escales de prismarina",
  "block.minecraft.prismarine_wall": "Mur de prismarina",
  "block.minecraft.pumpkin": "Carbassa",
  "block.minecraft.pumpkin_stem": "Tija de carabassa",
  "block.minecraft.purple_banner": "Estendard de porpra",
  "block.minecraft.purple_bed": "Llit lila",
  "block.minecraft.purple_candle": "Espelma lila",
  "block.minecraft.purple_candle_cake": "Pastís amb espelma lila",
  "block.minecraft.purple_carpet": "Catifa lila",
  "block.minecraft.purple_concrete": "Formigó morat",
  "block.minecraft.purple_concrete_powder": "Pols de formigó morat",
  "block.minecraft.purple_glazed_terracotta": "Rajola morada",
  "block.minecraft.purple_shulker_box": "Caixa de shulker lila",
  "block.minecraft.purple_stained_glass": "Vidre tenyit de lila",
  "block.minecraft.purple_stained_glass_pane": "Panell de vidre tenyit de lila",
  "block.minecraft.purple_terracotta": "Terracota morada",
  "block.minecraft.purple_wool": "Llana lila",
  "block.minecraft.purpur_block": "Bloc de purpur",
  "block.minecraft.purpur_pillar": "Pilar de purpur",
  "block.minecraft.purpur_slab": "Llosa de purpur",
  "block.minecraft.purpur_stairs": "Escales de purpur",
  "block.minecraft.quartz_block": "Bloc de quars",
  "block.minecraft.quartz_bricks": "Maons de quars",
  "block.minecraft.quartz_pillar": "Pilar de quars",
  "block.minecraft.quartz_slab": "Llosa de quars",
  "block.minecraft.quartz_stairs": "Escales de quars",
  "block.minecraft.rail": "Rail",
  "block.minecraft.raw_copper_block": "Bloc de coure en brut",
  "block.minecraft.raw_gold_block": "Bloc d'or en brut",
  "block.minecraft.raw_iron_block": "Bloc de ferro en brut",
  "block.minecraft.red_banner": "Estendard de gules",
  "block.minecraft.red_bed": "Llit vermell",
  "block.minecraft.red_candle": "Espelma vermella",
  "block.minecraft.red_candle_cake": "Pastís amb espelma vermella",
  "block.minecraft.red_carpet": "Catifa vermella",
  "block.minecraft.red_concrete": "Formigó vermell",
  "block.minecraft.red_concrete_powder": "Pols de formigó vermell",
  "block.minecraft.red_glazed_terracotta": "Rajola vermella",
  "block.minecraft.red_mushroom": "Bolet vermell",
  "block.minecraft.red_mushroom_block": "Bloc de bolet vermell",
  "block.minecraft.red_nether_brick_slab": "Llosa de maons del Nether vermells",
  "block.minecraft.red_nether_brick_stairs": "Escales de maons del Nether vermells",
  "block.minecraft.red_nether_brick_wall": "Mur de maons del Nether vermells",
  "block.minecraft.red_nether_bricks": "Maons del Nether vermells",
  "block.minecraft.red_sand": "Sorra vermella",
  "block.minecraft.red_sandstone": "Roca sorrenca vermella",
  "block.minecraft.red_sandstone_slab": "Llosa de roca sorrenca vermella",
  "block.minecraft.red_sandstone_stairs": "Escales de roca sorrenca vermella",
  "block.minecraft.red_sandstone_wall": "Mur de roca sorrenca vermella",
  "block.minecraft.red_shulker_box": "Caixa de shulker vermella",
  "block.minecraft.red_stained_glass": "Vidre tenyit de vermell",
  "block.minecraft.red_stained_glass_pane": "Panell de vidre tenyit de vermell",
  "block.minecraft.red_terracotta": "Terracota vermella",
  "block.minecraft.red_tulip": "Tulipa vermella",
  "block.minecraft.red_wool": "Llana vermella",
  "block.minecraft.redstone_block": "Bloc de redstone",
  "block.minecraft.redstone_lamp": "Làmpada de redstone",
  "block.minecraft.redstone_ore": "Mena de redstone",
  "block.minecraft.redstone_torch": "Torxa de redstone",
  "block.minecraft.redstone_wall_torch": "Torxa de redstone a la paret",
  "block.minecraft.redstone_wire": "Cable de redstone",
  "block.minecraft.reinforced_deepslate": "Pissarra reforçada",
  "block.minecraft.repeater": "Repetidor",
  "block.minecraft.repeating_command_block": "Bloc de comandaments repetitiu",
  "block.minecraft.resin_block": "Bloc de resina",
  "block.minecraft.resin_brick_slab": "Llosa de maons de resina",
  "block.minecraft.resin_brick_stairs": "Escales de maons de resina",
  "block.minecraft.resin_brick_wall": "Mur de maons de resina",
  "block.minecraft.resin_bricks": "Maons de resina",
  "block.minecraft.resin_clump": "Grumoll de resina",
  "block.minecraft.respawn_anchor": "Àncora de reaparició",
  "block.minecraft.rooted_dirt": "Terra amb arrels",
  "block.minecraft.rose_bush": "Roser",
  "block.minecraft.sand": "Sorra",
  "block.minecraft.sandstone": "Roca sorrenca",
  "block.minecraft.sandstone_slab": "Llosa de roca sorrenca",
  "block.minecraft.sandstone_stairs": "Escales de roca sorrenca",
  "block.minecraft.sandstone_wall": "Mur de roca sorrenca",
  "block.minecraft.scaffolding": "Bastida",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk catalitzador",
  "block.minecraft.sculk_sensor": "Sensor sculk",
  "block.minecraft.sculk_shrieker": "Sculk xisclador",
  "block.minecraft.sculk_vein": "Nervis d'sculk",
  "block.minecraft.sea_lantern": "Llanterna marina",
  "block.minecraft.sea_pickle": "Cogombre de mar",
  "block.minecraft.seagrass": "Herba marina",
  "block.minecraft.set_spawn": "Punt de reaparició establert",
  "block.minecraft.short_dry_grass": "Herba seca baixa",
  "block.minecraft.short_grass": "Herba curta",
  "block.minecraft.shroomlight": "Girgolàmpada",
  "block.minecraft.shulker_box": "Caixa de shulker",
  "block.minecraft.skeleton_skull": "Calavera d'esquelet",
  "block.minecraft.skeleton_wall_skull": "Calavera d'esquelet a la paret",
  "block.minecraft.slime_block": "Bloc de llim",
  "block.minecraft.small_amethyst_bud": "Cristall d'ametista petit",
  "block.minecraft.small_dripleaf": "Degotadora petita",
  "block.minecraft.smithing_table": "Taula de ferreria",
  "block.minecraft.smoker": "Fumador",
  "block.minecraft.smooth_basalt": "Basalt llis",
  "block.minecraft.smooth_quartz": "Bloc de quars llis",
  "block.minecraft.smooth_quartz_slab": "Llosa de quars llis",
  "block.minecraft.smooth_quartz_stairs": "Escales de quars llis",
  "block.minecraft.smooth_red_sandstone": "Roca sorrenca llisa",
  "block.minecraft.smooth_red_sandstone_slab": "Llosa de roca sorrenca vermella llisa",
  "block.minecraft.smooth_red_sandstone_stairs": "Escales de roca sorrenca vermella llisa",
  "block.minecraft.smooth_sandstone": "Roca sorrenca llisa",
  "block.minecraft.smooth_sandstone_slab": "Llosa de roca sorrenca llisa",
  "block.minecraft.smooth_sandstone_stairs": "Escales de roca sorrenca llisa",
  "block.minecraft.smooth_stone": "Roca llisa",
  "block.minecraft.smooth_stone_slab": "Llosa de roca llisa",
  "block.minecraft.sniffer_egg": "Ou d'ensumador",
  "block.minecraft.snow": "Neu",
  "block.minecraft.snow_block": "Bloc de neu",
  "block.minecraft.soul_campfire": "Foguera d'ànimes",
  "block.minecraft.soul_fire": "Foc d'ànimes",
  "block.minecraft.soul_lantern": "Llanterna d'ànimes",
  "block.minecraft.soul_sand": "Sorra d'ànimes",
  "block.minecraft.soul_soil": "Sòl d'ànimes",
  "block.minecraft.soul_torch": "Torxa d'ànimes",
  "block.minecraft.soul_wall_torch": "Torxa d'ànimes a la paret",
  "block.minecraft.spawn.not_valid": "No tens llit o una àncora de reaparició carregada, o ha estat obstruït/da",
  "block.minecraft.spawner": "Generador de monstres",
  "block.minecraft.spawner.desc1": "Al fer-hi clic amb un ou generador:",
  "block.minecraft.spawner.desc2": "Estableix el tipus d'entitat",
  "block.minecraft.sponge": "Esponja",
  "block.minecraft.spore_blossom": "Flor d'espores",
  "block.minecraft.spruce_button": "Botó de pi",
  "block.minecraft.spruce_door": "Porta de pi",
  "block.minecraft.spruce_fence": "Tanca de pi",
  "block.minecraft.spruce_fence_gate": "Porta de tanca de pi",
  "block.minecraft.spruce_hanging_sign": "Cartell penjant de pi",
  "block.minecraft.spruce_leaves": "Fulles de pi",
  "block.minecraft.spruce_log": "Tronc de pi",
  "block.minecraft.spruce_planks": "Fusta de pi",
  "block.minecraft.spruce_pressure_plate": "Placa de pressió de pi",
  "block.minecraft.spruce_sapling": "Esqueix de pi",
  "block.minecraft.spruce_shelf": "Prestatge de pi",
  "block.minecraft.spruce_sign": "Cartell de pi",
  "block.minecraft.spruce_slab": "Llosa de pi",
  "block.minecraft.spruce_stairs": "Escales de pi",
  "block.minecraft.spruce_trapdoor": "Trapa de pi",
  "block.minecraft.spruce_wall_hanging_sign": "Cartell penjant de pi amb suport",
  "block.minecraft.spruce_wall_sign": "Cartell de pi a la paret",
  "block.minecraft.spruce_wood": "Fusta de pi",
  "block.minecraft.sticky_piston": "Pistó enganxós",
  "block.minecraft.stone": "Roca",
  "block.minecraft.stone_brick_slab": "Llosa de maons de roca",
  "block.minecraft.stone_brick_stairs": "Escales de maons de roca",
  "block.minecraft.stone_brick_wall": "Mur de maons de roca",
  "block.minecraft.stone_bricks": "Maons de roca",
  "block.minecraft.stone_button": "Botó de roca",
  "block.minecraft.stone_pressure_plate": "Placa de pressió de roca",
  "block.minecraft.stone_slab": "Llosa de roca",
  "block.minecraft.stone_stairs": "Escales de roca",
  "block.minecraft.stonecutter": "Talla-roques",
  "block.minecraft.stripped_acacia_log": "Tronc d'acàcia escorçat",
  "block.minecraft.stripped_acacia_wood": "Fusta d'acàcia escorçada",
  "block.minecraft.stripped_bamboo_block": "Bloc de bambú escorçat",
  "block.minecraft.stripped_birch_log": "Tronc de bedoll escorçat",
  "block.minecraft.stripped_birch_wood": "Fusta de bedoll escorçada",
  "block.minecraft.stripped_cherry_log": "Tronc de cirerer escorçat",
  "block.minecraft.stripped_cherry_wood": "Fusta de cirerer escorçada",
  "block.minecraft.stripped_crimson_hyphae": "Hifes carmesines escorçades",
  "block.minecraft.stripped_crimson_stem": "Peu carmesí escorçat",
  "block.minecraft.stripped_dark_oak_log": "Tronc de pomer fosc escorçat",
  "block.minecraft.stripped_dark_oak_wood": "Fusta de pomer fosc escorçada",
  "block.minecraft.stripped_jungle_log": "Tronc de jungla escorçat",
  "block.minecraft.stripped_jungle_wood": "Fusta de jungla escorçada",
  "block.minecraft.stripped_mangrove_log": "Tronc de mangle escorçat",
  "block.minecraft.stripped_mangrove_wood": "Fusta de mangle escorçada",
  "block.minecraft.stripped_oak_log": "Tronc de pomer escorçat",
  "block.minecraft.stripped_oak_wood": "Fusta de pomer escorçada",
  "block.minecraft.stripped_pale_oak_log": "Tronc de roure pàl·lid escorçat",
  "block.minecraft.stripped_pale_oak_wood": "Fusta de roure pàl·lid escorçada",
  "block.minecraft.stripped_spruce_log": "Tronc de pi escorçat",
  "block.minecraft.stripped_spruce_wood": "Fusta de pi escorçada",
  "block.minecraft.stripped_warped_hyphae": "Hifes guerxes escorçades",
  "block.minecraft.stripped_warped_stem": "Peu guerxo escorçat",
  "block.minecraft.structure_block": "Bloc estructural",
  "block.minecraft.structure_void": "Buit estructural",
  "block.minecraft.sugar_cane": "Canya de sucre",
  "block.minecraft.sunflower": "Gira-sol",
  "block.minecraft.suspicious_gravel": "Grava sospitosa",
  "block.minecraft.suspicious_sand": "Sorra sospitosa",
  "block.minecraft.sweet_berry_bush": "Arbust de baies dolces",
  "block.minecraft.tall_dry_grass": "Herba seca alta",
  "block.minecraft.tall_grass": "Herba alta",
  "block.minecraft.tall_seagrass": "Herba marina alta",
  "block.minecraft.target": "Blanc",
  "block.minecraft.terracotta": "Terracota",
  "block.minecraft.test_block": "Bloc de proves",
  "block.minecraft.test_instance_block": "Bloc de prova d'instàncies",
  "block.minecraft.tinted_glass": "Vidre opac",
  "block.minecraft.tnt": "Dinamita",
  "block.minecraft.tnt.disabled": "Les explosions de TNT estan deshabilitades",
  "block.minecraft.torch": "Torxa",
  "block.minecraft.torchflower": "Florxa",
  "block.minecraft.torchflower_crop": "Cultiu de florxa",
  "block.minecraft.trapped_chest": "Cofre trampa",
  "block.minecraft.trial_spawner": "Generador de reptes",
  "block.minecraft.tripwire": "Corda",
  "block.minecraft.tripwire_hook": "Ganxo",
  "block.minecraft.tube_coral": "Corall de tub",
  "block.minecraft.tube_coral_block": "Bloc de corall de tub",
  "block.minecraft.tube_coral_fan": "Gorgònia de tub",
  "block.minecraft.tube_coral_wall_fan": "Gorgònia de tub a la paret",
  "block.minecraft.tuff": "Tuf",
  "block.minecraft.tuff_brick_slab": "Llosa de maons de tuf ",
  "block.minecraft.tuff_brick_stairs": "Escales de maons de tuf",
  "block.minecraft.tuff_brick_wall": "Mur de maons de tuf",
  "block.minecraft.tuff_bricks": "Maons de tuf",
  "block.minecraft.tuff_slab": "Llosa de tuf",
  "block.minecraft.tuff_stairs": "Escales de tuf",
  "block.minecraft.tuff_wall": "Mur de tuf",
  "block.minecraft.turtle_egg": "Ou de tortuga",
  "block.minecraft.twisting_vines": "Lianes retorçades",
  "block.minecraft.twisting_vines_plant": "Lianes retorçades",
  "block.minecraft.vault": "Caixa forta",
  "block.minecraft.verdant_froglight": "Granollum verdosa",
  "block.minecraft.vine": "Lianes",
  "block.minecraft.void_air": "Aire del buit",
  "block.minecraft.wall_torch": "Torxa a la paret",
  "block.minecraft.warped_button": "Botó guerxo",
  "block.minecraft.warped_door": "Porta guerxa",
  "block.minecraft.warped_fence": "Tanca guerxa",
  "block.minecraft.warped_fence_gate": "Porta de tanca guerxa",
  "block.minecraft.warped_fungus": "Fong guerxo",
  "block.minecraft.warped_hanging_sign": "Cartell penjant guerxo",
  "block.minecraft.warped_hyphae": "Hifes guerxes",
  "block.minecraft.warped_nylium": "Netheli guerxo",
  "block.minecraft.warped_planks": "Fusta guerxa",
  "block.minecraft.warped_pressure_plate": "Placa de pressió guerxa",
  "block.minecraft.warped_roots": "Arrels guerxes",
  "block.minecraft.warped_shelf": "Prestatge guerxo",
  "block.minecraft.warped_sign": "Cartell guerxo",
  "block.minecraft.warped_slab": "Llosa guerxa",
  "block.minecraft.warped_stairs": "Escales guerxes",
  "block.minecraft.warped_stem": "Peu guerxo",
  "block.minecraft.warped_trapdoor": "Trapa guerxa",
  "block.minecraft.warped_wall_hanging_sign": "Cartell penjant guerxo amb suport",
  "block.minecraft.warped_wall_sign": "Cartell guerxo a la paret",
  "block.minecraft.warped_wart_block": "Bloc de berrugues guerxes",
  "block.minecraft.water": "Aigua",
  "block.minecraft.water_cauldron": "Calderó amb aigua",
  "block.minecraft.waxed_chiseled_copper": "Coure encerat cisellat",
  "block.minecraft.waxed_copper_bars": "Barrots de coure encerats",
  "block.minecraft.waxed_copper_block": "Bloc de coure encerat",
  "block.minecraft.waxed_copper_bulb": "Bombeta de coure encerat",
  "block.minecraft.waxed_copper_chain": "Cadena de coure encerada",
  "block.minecraft.waxed_copper_chest": "Cofre de coure encerat",
  "block.minecraft.waxed_copper_door": "Porta de coure encerat",
  "block.minecraft.waxed_copper_golem_statue": "Estàtua de gòlem de coure encerada",
  "block.minecraft.waxed_copper_grate": "Reixa de coure encerat",
  "block.minecraft.waxed_copper_lantern": "Fanal de coure encerat",
  "block.minecraft.waxed_copper_trapdoor": "Trapa de coure encerat",
  "block.minecraft.waxed_cut_copper": "Coure tallat encerat",
  "block.minecraft.waxed_cut_copper_slab": "Llosa de coure tallat encerada",
  "block.minecraft.waxed_cut_copper_stairs": "Escales de coure tallat encerades",
  "block.minecraft.waxed_exposed_chiseled_copper": "Coure exposat encerat cisellat",
  "block.minecraft.waxed_exposed_copper": "Coure exposat encerat",
  "block.minecraft.waxed_exposed_copper_bars": "Barrots de coure exposat encerats",
  "block.minecraft.waxed_exposed_copper_bulb": "Bombeta de coure exposat encerat",
  "block.minecraft.waxed_exposed_copper_chain": "Cadena de coure exposat encerada",
  "block.minecraft.waxed_exposed_copper_chest": "Cofre de coure exposat encerat",
  "block.minecraft.waxed_exposed_copper_door": "Porta de coure exposat encerat",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Estàtua de gòlem de coure exposat encerada",
  "block.minecraft.waxed_exposed_copper_grate": "Reixa de coure exposat encerat",
  "block.minecraft.waxed_exposed_copper_lantern": "Fanal de coure exposat encerat",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Trapa de coure exposat encerat",
  "block.minecraft.waxed_exposed_cut_copper": "Coure tallat exposat encerat",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Llosa de coure tallat exposada encerada",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Escales de coure tallat exposades encerades",
  "block.minecraft.waxed_exposed_lightning_rod": "Parallamps exposat encerat",
  "block.minecraft.waxed_lightning_rod": "Parallamps encerat",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Coure oxidat encerat cisellat",
  "block.minecraft.waxed_oxidized_copper": "Coure oxidat encerat",
  "block.minecraft.waxed_oxidized_copper_bars": "Barrots de coure oxidat exposats",
  "block.minecraft.waxed_oxidized_copper_bulb": "Bombeta de coure oxidat encerat",
  "block.minecraft.waxed_oxidized_copper_chain": "Cadena de coure oxidat encerada",
  "block.minecraft.waxed_oxidized_copper_chest": "Cofre de coure oxidat encerat",
  "block.minecraft.waxed_oxidized_copper_door": "Porta de coure oxidat encerat",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Estàtua de coure exposat oxidada",
  "block.minecraft.waxed_oxidized_copper_grate": "Reixa de coure oxidat encerat",
  "block.minecraft.waxed_oxidized_copper_lantern": "Fanal de coure oxidat encerat",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Trapa de coure oxidat encerat",
  "block.minecraft.waxed_oxidized_cut_copper": "Coure tallat oxidat encerat",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Llosa de coure tallat oxidat encerada",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Escales de coure tallat oxidat encerades",
  "block.minecraft.waxed_oxidized_lightning_rod": "Parallamps oxidat encerat",
  "block.minecraft.waxed_weathered_chiseled_copper": "Coure corroït encerat cisellat",
  "block.minecraft.waxed_weathered_copper": "Coure corroït encerat",
  "block.minecraft.waxed_weathered_copper_bars": "Barres de coure encerades i desgastades",
  "block.minecraft.waxed_weathered_copper_bulb": "Bombeta de coure corroït encerat",
  "block.minecraft.waxed_weathered_copper_chain": "Cadena de coure corroït encerada",
  "block.minecraft.waxed_weathered_copper_chest": "Waxed Weathered Copper Chest",
  "block.minecraft.waxed_weathered_copper_door": "Porta de coure corroït encerat",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Estàtua de gòlem de coure corroït encerada",
  "block.minecraft.waxed_weathered_copper_grate": "Reixa de coure corroït encerat",
  "block.minecraft.waxed_weathered_copper_lantern": "Fanal de coure corroït encerat",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Trapa de coure corroït encerat",
  "block.minecraft.waxed_weathered_cut_copper": "Coure tallat corroït encerat",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Llosa de coure tallat corroïda encerada",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Escales de coure tallat corroïdes encerades",
  "block.minecraft.waxed_weathered_lightning_rod": "Parallamps corroït encerat",
  "block.minecraft.weathered_chiseled_copper": "Coure corroït cisellat",
  "block.minecraft.weathered_copper": "Coure corroït",
  "block.minecraft.weathered_copper_bars": "Barrots de coure corroït",
  "block.minecraft.weathered_copper_bulb": "Bombeta de coure corroït",
  "block.minecraft.weathered_copper_chain": "Cadena de coure corroït",
  "block.minecraft.weathered_copper_chest": "Cofre de coure corroït",
  "block.minecraft.weathered_copper_door": "Porta de coure corroït",
  "block.minecraft.weathered_copper_golem_statue": "Estàtua de gòlem de coure corroit",
  "block.minecraft.weathered_copper_grate": "Reixa de coure corroït",
  "block.minecraft.weathered_copper_lantern": "Fanal de coure corroït",
  "block.minecraft.weathered_copper_trapdoor": "Trapa de coure corroït",
  "block.minecraft.weathered_cut_copper": "Coure tallat corroït",
  "block.minecraft.weathered_cut_copper_slab": "Llosa de coure tallat corroïda",
  "block.minecraft.weathered_cut_copper_stairs": "Escales de coure tallat corroïdes",
  "block.minecraft.weathered_lightning_rod": "Parallamps corroït",
  "block.minecraft.weeping_vines": "Lianes ploroses",
  "block.minecraft.weeping_vines_plant": "Lianes ploroses",
  "block.minecraft.wet_sponge": "Esponja humida",
  "block.minecraft.wheat": "Cultiu de blat",
  "block.minecraft.white_banner": "Estendard blanc",
  "block.minecraft.white_bed": "Llit blanc",
  "block.minecraft.white_candle": "Espelma blanca",
  "block.minecraft.white_candle_cake": "Pastís amb espelma blanca",
  "block.minecraft.white_carpet": "Catifa blanca",
  "block.minecraft.white_concrete": "Formigó blanc",
  "block.minecraft.white_concrete_powder": "Pols de formigó blanc",
  "block.minecraft.white_glazed_terracotta": "Rajola blanca",
  "block.minecraft.white_shulker_box": "Caixa de shulker blanca",
  "block.minecraft.white_stained_glass": "Vidre tenyit de blanc",
  "block.minecraft.white_stained_glass_pane": "Panell de vidre tenyit de blanc",
  "block.minecraft.white_terracotta": "Terracota blanca",
  "block.minecraft.white_tulip": "Tulipa blanca",
  "block.minecraft.white_wool": "Llana blanca",
  "block.minecraft.wildflowers": "Flors silvestres",
  "block.minecraft.wither_rose": "Rosa de wither",
  "block.minecraft.wither_skeleton_skull": "Calavera d'esquelet wither",
  "block.minecraft.wither_skeleton_wall_skull": "Calavera d'esquelet wither a la paret",
  "block.minecraft.yellow_banner": "Estendard d'or",
  "block.minecraft.yellow_bed": "Llit groc",
  "block.minecraft.yellow_candle": "Espelma groga",
  "block.minecraft.yellow_candle_cake": "Pastís amb espelma groga",
  "block.minecraft.yellow_carpet": "Catifa groga",
  "block.minecraft.yellow_concrete": "Formigó groc",
  "block.minecraft.yellow_concrete_powder": "Pols de formigó groc",
  "block.minecraft.yellow_glazed_terracotta": "Rajola groga",
  "block.minecraft.yellow_shulker_box": "Caixa de shulker groga",
  "block.minecraft.yellow_stained_glass": "Vidre tenyit de groc",
  "block.minecraft.yellow_stained_glass_pane": "Panell de vidre tenyit de groc",
  "block.minecraft.yellow_terracotta": "Terracota groga",
  "block.minecraft.yellow_wool": "Llana groga",
  "block.minecraft.zombie_head": "Cap de zombi",
  "block.minecraft.zombie_wall_head": "Cap de zombi a la paret",
  "item.minecraft.acacia_boat": "Barca d'acàcia",
  "item.minecraft.acacia_chest_boat": "Barca d'acàcia amb cofre",
  "item.minecraft.allay_spawn_egg": "Generar allay",
  "item.minecraft.amethyst_shard": "Fragment d’ametista",
  "item.minecraft.angler_pottery_shard": "Fragment de ceràmica de canya de pescar",
  "item.minecraft.angler_pottery_sherd": "Fragment de ceràmica de canya de pescar",
  "item.minecraft.apple": "Poma",
  "item.minecraft.archer_pottery_shard": "Fragment de ceràmica d'arquer",
  "item.minecraft.archer_pottery_sherd": "Fragment de ceràmica d'arquer",
  "item.minecraft.armadillo_scute": "Escata d'armadillo",
  "item.minecraft.armadillo_spawn_egg": "Generar armadillo",
  "item.minecraft.armor_stand": "Maniquí",
  "item.minecraft.arms_up_pottery_shard": "Fragment de ceràmica de ninot",
  "item.minecraft.arms_up_pottery_sherd": "Fragment de ceràmica de ninot",
  "item.minecraft.arrow": "Fletxa",
  "item.minecraft.axolotl_bucket": "Galleda amb axolot",
  "item.minecraft.axolotl_spawn_egg": "Generar axolot",
  "item.minecraft.baked_potato": "Patata cuita",
  "item.minecraft.bamboo_chest_raft": "Rai de bambú amb cofre",
  "item.minecraft.bamboo_raft": "Rai de bambú",
  "item.minecraft.bat_spawn_egg": "Generar ratpenat",
  "item.minecraft.bee_spawn_egg": "Generar abella",
  "item.minecraft.beef": "Bistec cru",
  "item.minecraft.beetroot": "Remolatxa",
  "item.minecraft.beetroot_seeds": "Llavors de remolatxa",
  "item.minecraft.beetroot_soup": "Sopa de remolatxa",
  "item.minecraft.birch_boat": "Barca de bedoll",
  "item.minecraft.birch_chest_boat": "Barca de bedoll amb cofre",
  "item.minecraft.black_bundle": "Sarró Negre",
  "item.minecraft.black_dye": "Tint negre",
  "item.minecraft.black_harness": "Arnès Negre",
  "item.minecraft.blade_pottery_shard": "Fragment de ceràmica d'espasa",
  "item.minecraft.blade_pottery_sherd": "Fragment de ceràmica d'espasa",
  "item.minecraft.blaze_powder": "Pols de foc",
  "item.minecraft.blaze_rod": "Vara flamejant",
  "item.minecraft.blaze_spawn_egg": "Generar esperit del foc",
  "item.minecraft.blue_bundle": "Sarró Blau",
  "item.minecraft.blue_dye": "Tint blau",
  "item.minecraft.blue_egg": "Ou blau",
  "item.minecraft.blue_harness": "Arnès Blau",
  "item.minecraft.bogged_spawn_egg": "Generador d'aiguamoll",
  "item.minecraft.bolt_armor_trim_smithing_template": "Patró de ferreria",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Patró d'armadura: Reblat",
  "item.minecraft.bone": "Os",
  "item.minecraft.bone_meal": "Farina d'ossos",
  "item.minecraft.book": "Llibre",
  "item.minecraft.bordure_indented_banner_pattern": "Patró de bordura dentada",
  "item.minecraft.bow": "Arc",
  "item.minecraft.bowl": "Bol",
  "item.minecraft.bread": "Pa",
  "item.minecraft.breeze_rod": "Vara de brisa",
  "item.minecraft.breeze_spawn_egg": "Generar brisa",
  "item.minecraft.brewer_pottery_shard": "Fragment de ceràmica de poció",
  "item.minecraft.brewer_pottery_sherd": "Fragment de ceràmica de poció",
  "item.minecraft.brewing_stand": "Altar de pocions",
  "item.minecraft.brick": "Maó",
  "item.minecraft.brown_bundle": "Sarró marró",
  "item.minecraft.brown_dye": "Tint marró",
  "item.minecraft.brown_egg": "Ou marró",
  "item.minecraft.brown_harness": "Arnès Marró",
  "item.minecraft.brush": "Pinzell",
  "item.minecraft.bucket": "Galleda",
  "item.minecraft.bundle": "Sarró",
  "item.minecraft.bundle.empty": "Buit",
  "item.minecraft.bundle.empty.description": "Pot contenir una pila mixta d'ítems",
  "item.minecraft.bundle.full": "Ple",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Fragment de ceràmica de foc",
  "item.minecraft.burn_pottery_sherd": "Fragment de ceràmica de foc",
  "item.minecraft.camel_husk_spawn_egg": "Ou de generació Dromedari esquelet sec",
  "item.minecraft.camel_spawn_egg": "Generar dromedari",
  "item.minecraft.carrot": "Pastanaga",
  "item.minecraft.carrot_on_a_stick": "Canya amb pastanaga",
  "item.minecraft.cat_spawn_egg": "Generar gat",
  "item.minecraft.cauldron": "Calderó",
  "item.minecraft.cave_spider_spawn_egg": "Generar aranya de cova",
  "item.minecraft.chainmail_boots": "Botes de cota de malla",
  "item.minecraft.chainmail_chestplate": "Cuirassa de cota de malla",
  "item.minecraft.chainmail_helmet": "Casc de cota de malla",
  "item.minecraft.chainmail_leggings": "Pantalons de cota de malla",
  "item.minecraft.charcoal": "Carbó vegetal",
  "item.minecraft.cherry_boat": "Barca de cirerer",
  "item.minecraft.cherry_chest_boat": "Barca de cirerer amb cofre",
  "item.minecraft.chest_minecart": "Vagoneta amb cofre",
  "item.minecraft.chicken": "Carn de pollastre",
  "item.minecraft.chicken_spawn_egg": "Generar pollastre",
  "item.minecraft.chorus_fruit": "Fruita de tornada",
  "item.minecraft.clay_ball": "Bola d'argila",
  "item.minecraft.clock": "Rellotge",
  "item.minecraft.coal": "Carbó",
  "item.minecraft.coast_armor_trim_smithing_template": "Patró de ferreria",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Patró d'armadura: Costa",
  "item.minecraft.cocoa_beans": "Grans de cacau",
  "item.minecraft.cod": "Bacallà cru",
  "item.minecraft.cod_bucket": "Galleda amb bacallà",
  "item.minecraft.cod_spawn_egg": "Generar bacallà",
  "item.minecraft.command_block_minecart": "Vagoneta amb bloc de comandaments",
  "item.minecraft.compass": "Brúixola",
  "item.minecraft.cooked_beef": "Bistec",
  "item.minecraft.cooked_chicken": "Pollastre rostit",
  "item.minecraft.cooked_cod": "Bacallà cuit",
  "item.minecraft.cooked_mutton": "Carn d'ovella cuita",
  "item.minecraft.cooked_porkchop": "Carn de porc cuita",
  "item.minecraft.cooked_rabbit": "Conill rostit",
  "item.minecraft.cooked_salmon": "Salmó cuit",
  "item.minecraft.cookie": "Galeta",
  "item.minecraft.copper_axe": "Destral de coure",
  "item.minecraft.copper_boots": "Botes de coure",
  "item.minecraft.copper_chestplate": "Cuirassa de coure",
  "item.minecraft.copper_golem_spawn_egg": "Generar gòlem de coure",
  "item.minecraft.copper_helmet": "Casc de coure",
  "item.minecraft.copper_hoe": "Aixada de coure",
  "item.minecraft.copper_horse_armor": "Armadura de coure per a cavalls",
  "item.minecraft.copper_ingot": "Lingot de coure",
  "item.minecraft.copper_leggings": "Malles de coure",
  "item.minecraft.copper_nautilus_armor": "Armadura de Nautilus de Coure",
  "item.minecraft.copper_nugget": "Grànul de coure",
  "item.minecraft.copper_pickaxe": "Pic de coure",
  "item.minecraft.copper_shovel": "Pala de coure",
  "item.minecraft.copper_spear": "Llança de Coure",
  "item.minecraft.copper_sword": "Espasa de coure",
  "item.minecraft.cow_spawn_egg": "Generar vaca",
  "item.minecraft.creaking_spawn_egg": "Generar cruixidor",
  "item.minecraft.creeper_banner_pattern": "Patró de creeper",
  "item.minecraft.creeper_banner_pattern.desc": "Estampat de creeper",
  "item.minecraft.creeper_banner_pattern.new": "Patró de creeper",
  "item.minecraft.creeper_spawn_egg": "Generar creeper",
  "item.minecraft.crossbow": "Ballesta",
  "item.minecraft.crossbow.projectile": "Projectil:",
  "item.minecraft.crossbow.projectile.multiple": "Projectil: %s X %s",
  "item.minecraft.crossbow.projectile.single": "Projectil: %s",
  "item.minecraft.cyan_bundle": "Sarró cian",
  "item.minecraft.cyan_dye": "Tint cian",
  "item.minecraft.cyan_harness": "Arnès Cian",
  "item.minecraft.danger_pottery_shard": "Fragment de ceràmica de creeper",
  "item.minecraft.danger_pottery_sherd": "Fragment de ceràmica de creeper",
  "item.minecraft.dark_oak_boat": "Barca de pomer fosc",
  "item.minecraft.dark_oak_chest_boat": "Barca de pomer fosc amb cofre",
  "item.minecraft.debug_stick": "Pal de proves",
  "item.minecraft.debug_stick.empty": "%s no té propietats",
  "item.minecraft.debug_stick.select": "has seleccionat \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" ha canviat a %s",
  "item.minecraft.diamond": "Diamant",
  "item.minecraft.diamond_axe": "Destral de diamant",
  "item.minecraft.diamond_boots": "Botes de diamant",
  "item.minecraft.diamond_chestplate": "Cuirassa de diamant",
  "item.minecraft.diamond_helmet": "Casc de diamant",
  "item.minecraft.diamond_hoe": "Aixada de diamant",
  "item.minecraft.diamond_horse_armor": "Armadura de diamant per a cavalls",
  "item.minecraft.diamond_leggings": "Malles de diamant",
  "item.minecraft.diamond_nautilus_armor": "Armadura de Nautilus de Diamant",
  "item.minecraft.diamond_pickaxe": "Pic de diamant",
  "item.minecraft.diamond_shovel": "Pala de diamant",
  "item.minecraft.diamond_spear": "Llança de Diamant",
  "item.minecraft.diamond_sword": "Espasa de diamant",
  "item.minecraft.disc_fragment_5": "Fragment de disc",
  "item.minecraft.disc_fragment_5.desc": "Disc de música - 5",
  "item.minecraft.dolphin_spawn_egg": "Generar dofí",
  "item.minecraft.donkey_spawn_egg": "Generar ruc",
  "item.minecraft.dragon_breath": "Alè de drac",
  "item.minecraft.dried_kelp": "Algues seques",
  "item.minecraft.drowned_spawn_egg": "Generar ofegat",
  "item.minecraft.dune_armor_trim_smithing_template": "Patró de ferreria",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Patró d'armadura: Duna",
  "item.minecraft.echo_shard": "Fragment d'eco",
  "item.minecraft.egg": "Ou",
  "item.minecraft.elder_guardian_spawn_egg": "Generar guardià ancià",
  "item.minecraft.elytra": "Èlitres",
  "item.minecraft.emerald": "Maragda",
  "item.minecraft.enchanted_book": "Llibre encantat",
  "item.minecraft.enchanted_golden_apple": "Poma daurada encantada",
  "item.minecraft.end_crystal": "Cristall de l'End",
  "item.minecraft.ender_dragon_spawn_egg": "Generar drac d'Ender",
  "item.minecraft.ender_eye": "Ull d'Ender",
  "item.minecraft.ender_pearl": "Perla d'Ender",
  "item.minecraft.enderman_spawn_egg": "Generar enderman",
  "item.minecraft.endermite_spawn_egg": "Generar endermite",
  "item.minecraft.evoker_spawn_egg": "Generar invocador",
  "item.minecraft.experience_bottle": "Ampolla màgica",
  "item.minecraft.explorer_pottery_shard": "Fragment de ceràmica de mapa",
  "item.minecraft.explorer_pottery_sherd": "Fragment de ceràmica de mapa",
  "item.minecraft.eye_armor_trim_smithing_template": "Patró de ferreria",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Patró d'armadura: Ull",
  "item.minecraft.feather": "Ploma",
  "item.minecraft.fermented_spider_eye": "Ull d'aranya fermentat",
  "item.minecraft.field_masoned_banner_pattern": "Patró de maçonat",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Càrrega de foc",
  "item.minecraft.firework_rocket": "Focs artificials",
  "item.minecraft.firework_rocket.flight": "Duració del vol:",
  "item.minecraft.firework_rocket.multiple_stars": "%s X %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Estrella de focs artificials",
  "item.minecraft.firework_star.black": "Negre",
  "item.minecraft.firework_star.blue": "Blau",
  "item.minecraft.firework_star.brown": "Marró",
  "item.minecraft.firework_star.custom_color": "Personalitzat",
  "item.minecraft.firework_star.cyan": "Cian",
  "item.minecraft.firework_star.fade_to": "Canviar a",
  "item.minecraft.firework_star.flicker": "Espurnejar",
  "item.minecraft.firework_star.gray": "Gris",
  "item.minecraft.firework_star.green": "Verd",
  "item.minecraft.firework_star.light_blue": "Blau cel",
  "item.minecraft.firework_star.light_gray": "Gris clar",
  "item.minecraft.firework_star.lime": "Llima",
  "item.minecraft.firework_star.magenta": "Magenta",
  "item.minecraft.firework_star.orange": "Taronja",
  "item.minecraft.firework_star.pink": "Rosa",
  "item.minecraft.firework_star.purple": "Lila",
  "item.minecraft.firework_star.red": "Vermell",
  "item.minecraft.firework_star.shape": "Forma desconeguda",
  "item.minecraft.firework_star.shape.burst": "Esclatar",
  "item.minecraft.firework_star.shape.creeper": "En forma de creeper",
  "item.minecraft.firework_star.shape.large_ball": "Esfera gran",
  "item.minecraft.firework_star.shape.small_ball": "Esfera petita",
  "item.minecraft.firework_star.shape.star": "En forma d'estrella",
  "item.minecraft.firework_star.trail": "Rastre",
  "item.minecraft.firework_star.white": "Blanc",
  "item.minecraft.firework_star.yellow": "Groc",
  "item.minecraft.fishing_rod": "Canya de pescar",
  "item.minecraft.flint": "Sílex",
  "item.minecraft.flint_and_steel": "Sílex i acer",
  "item.minecraft.flow_armor_trim_smithing_template": "Patró de ferreria",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Patró d'armadura: Espiral",
  "item.minecraft.flow_banner_pattern": "Patró d'espiral",
  "item.minecraft.flow_banner_pattern.desc": "Espiral",
  "item.minecraft.flow_banner_pattern.new": "Estampat d'espiral",
  "item.minecraft.flow_pottery_sherd": "Fragment de ceràmica d'espiral",
  "item.minecraft.flower_banner_pattern": "Patró de flor",
  "item.minecraft.flower_banner_pattern.desc": "Estampat de flor",
  "item.minecraft.flower_banner_pattern.new": "Estampat de flor",
  "item.minecraft.flower_pot": "Test",
  "item.minecraft.fox_spawn_egg": "Generar guineu",
  "item.minecraft.friend_pottery_shard": "Fragment de ceràmica d'amistat",
  "item.minecraft.friend_pottery_sherd": "Fragment de ceràmica d'amistat",
  "item.minecraft.frog_spawn_egg": "Generar granota",
  "item.minecraft.furnace_minecart": "Vagoneta amb forn",
  "item.minecraft.ghast_spawn_egg": "Generar ghast",
  "item.minecraft.ghast_tear": "Llàgrima de ghast",
  "item.minecraft.glass_bottle": "Ampolla de vidre",
  "item.minecraft.glistering_melon_slice": "Tallada de síndria daurada",
  "item.minecraft.globe_banner_pattern": "Patró de planeta",
  "item.minecraft.globe_banner_pattern.desc": "Estampat de planeta",
  "item.minecraft.globe_banner_pattern.new": "Estampat de planeta",
  "item.minecraft.glow_berries": "Baies brillants",
  "item.minecraft.glow_ink_sac": "Sac de tinta lluent",
  "item.minecraft.glow_item_frame": "Marc lluent",
  "item.minecraft.glow_squid_spawn_egg": "Generar calamar lluent",
  "item.minecraft.glowstone_dust": "Pols de roca brillant",
  "item.minecraft.goat_horn": "Banya de cabra",
  "item.minecraft.goat_spawn_egg": "Generar cabra",
  "item.minecraft.gold_ingot": "Lingot d'or",
  "item.minecraft.gold_nugget": "Grànul d'or",
  "item.minecraft.golden_apple": "Poma d'or",
  "item.minecraft.golden_axe": "Destral d'or",
  "item.minecraft.golden_boots": "Botes d'or",
  "item.minecraft.golden_carrot": "Pastanaga daurada",
  "item.minecraft.golden_chestplate": "Cuirassa d'or",
  "item.minecraft.golden_helmet": "Casc d'or",
  "item.minecraft.golden_hoe": "Aixada d'or",
  "item.minecraft.golden_horse_armor": "Armadura d'or per a cavalls",
  "item.minecraft.golden_leggings": "Malles d'or",
  "item.minecraft.golden_nautilus_armor": "Armadura de Nautilus daurada",
  "item.minecraft.golden_pickaxe": "Pic d'or",
  "item.minecraft.golden_shovel": "Pala d'or",
  "item.minecraft.golden_spear": "Llança daurada",
  "item.minecraft.golden_sword": "Espasa d'or",
  "item.minecraft.gray_bundle": "Sarró gris",
  "item.minecraft.gray_dye": "Tint gris",
  "item.minecraft.gray_harness": "Arnès Gris",
  "item.minecraft.green_bundle": "Sarró verd",
  "item.minecraft.green_dye": "Tint verd",
  "item.minecraft.green_harness": "Arnès verd",
  "item.minecraft.guardian_spawn_egg": "Generar guardià",
  "item.minecraft.gunpowder": "Pólvora",
  "item.minecraft.guster_banner_pattern": "Patró de brisa",
  "item.minecraft.guster_banner_pattern.desc": "Brisa",
  "item.minecraft.guster_banner_pattern.new": "Estampat de brisa",
  "item.minecraft.guster_pottery_sherd": "Fragment de ceràmica de brisa",
  "item.minecraft.happy_ghast_spawn_egg": "Generar Ghast Feliç",
  "item.minecraft.harness": "Arnès",
  "item.minecraft.heart_of_the_sea": "Cor del mar",
  "item.minecraft.heart_pottery_shard": "Fragment de ceràmica d'amor",
  "item.minecraft.heart_pottery_sherd": "Fragment de ceràmica d'amor",
  "item.minecraft.heartbreak_pottery_shard": "Fragment de ceràmica de desamor",
  "item.minecraft.heartbreak_pottery_sherd": "Fragment de ceràmica de desamor",
  "item.minecraft.hoglin_spawn_egg": "Generar hoglin",
  "item.minecraft.honey_bottle": "Pot de mel",
  "item.minecraft.honeycomb": "Bresca",
  "item.minecraft.hopper_minecart": "Vagoneta amb tremuja",
  "item.minecraft.horse_spawn_egg": "Generar cavall",
  "item.minecraft.host_armor_trim_smithing_template": "Patró de ferreria",
  "item.minecraft.host_armor_trim_smithing_template.new": "Disseny d'armadura d'amfitrió",
  "item.minecraft.howl_pottery_shard": "Fragment de ceràmica de llop",
  "item.minecraft.howl_pottery_sherd": "Fragment de ceràmica de llop",
  "item.minecraft.husk_spawn_egg": "Generar zombi ressec",
  "item.minecraft.ink_sac": "Sac de tinta",
  "item.minecraft.iron_axe": "Destral de ferro",
  "item.minecraft.iron_boots": "Botes de ferro",
  "item.minecraft.iron_chestplate": "Cuirassa de ferro",
  "item.minecraft.iron_golem_spawn_egg": "Generar gòlem de ferro",
  "item.minecraft.iron_helmet": "Casc de ferro",
  "item.minecraft.iron_hoe": "Aixada de ferro",
  "item.minecraft.iron_horse_armor": "Armadura de ferro per a cavalls",
  "item.minecraft.iron_ingot": "Lingot de ferro",
  "item.minecraft.iron_leggings": "Malles de ferro",
  "item.minecraft.iron_nautilus_armor": "Armadura de Nautilus de ferro",
  "item.minecraft.iron_nugget": "Grànul de ferro",
  "item.minecraft.iron_pickaxe": "Pic de ferro",
  "item.minecraft.iron_shovel": "Pala de ferro",
  "item.minecraft.iron_spear": "Llança de ferro",
  "item.minecraft.iron_sword": "Espasa de ferro",
  "item.minecraft.item_frame": "Marc",
  "item.minecraft.jungle_boat": "Barca de jungla",
  "item.minecraft.jungle_chest_boat": "Barca de jungla amb cofre",
  "item.minecraft.knowledge_book": "Llibre del coneixement",
  "item.minecraft.lapis_lazuli": "Lapislàtzuli",
  "item.minecraft.lava_bucket": "Galleda de lava",
  "item.minecraft.lead": "Llaç",
  "item.minecraft.leather": "Cuir",
  "item.minecraft.leather_boots": "Botes de cuir",
  "item.minecraft.leather_chestplate": "Túnica de cuir",
  "item.minecraft.leather_helmet": "Casc de cuir",
  "item.minecraft.leather_horse_armor": "Armadura de cuir per a cavalls",
  "item.minecraft.leather_leggings": "Pantalons de cuir",
  "item.minecraft.light_blue_bundle": "Sarró blau cel",
  "item.minecraft.light_blue_dye": "Tint blau clar",
  "item.minecraft.light_blue_harness": "Arnès Blau Clar",
  "item.minecraft.light_gray_bundle": "Sarró gris clar",
  "item.minecraft.light_gray_dye": "Tint gris clar",
  "item.minecraft.light_gray_harness": "Arnès Gris Clar",
  "item.minecraft.lime_bundle": "Sarró llima",
  "item.minecraft.lime_dye": "Tint llima",
  "item.minecraft.lime_harness": "Arnès Llima",
  "item.minecraft.lingering_potion": "Poció persistent",
  "item.minecraft.lingering_potion.effect.awkward": "Poció estranya persistent",
  "item.minecraft.lingering_potion.effect.empty": "Poció persistent impossible d'elaborar",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Poció de resistència ígnia persistent",
  "item.minecraft.lingering_potion.effect.harming": "Poció danyosa persistent",
  "item.minecraft.lingering_potion.effect.healing": "Poció de curació persistent",
  "item.minecraft.lingering_potion.effect.infested": "Poció d'infestació persistent",
  "item.minecraft.lingering_potion.effect.invisibility": "Poció d'invisibilitat persistent",
  "item.minecraft.lingering_potion.effect.leaping": "Poció de salt persistent",
  "item.minecraft.lingering_potion.effect.levitation": "Poció de levitació persistent",
  "item.minecraft.lingering_potion.effect.luck": "Poció sortosa persistent",
  "item.minecraft.lingering_potion.effect.mundane": "Poció mundana persistent",
  "item.minecraft.lingering_potion.effect.night_vision": "Poció de visió nocturna persistent",
  "item.minecraft.lingering_potion.effect.oozing": "Poció de supura persistent",
  "item.minecraft.lingering_potion.effect.poison": "Poció verinosa persistent",
  "item.minecraft.lingering_potion.effect.regeneration": "Poció de regeneració persistent",
  "item.minecraft.lingering_potion.effect.slow_falling": "Poció persistent de caiguda lenta",
  "item.minecraft.lingering_potion.effect.slowness": "Poció alentidora persistent",
  "item.minecraft.lingering_potion.effect.strength": "Poció de força persistent",
  "item.minecraft.lingering_potion.effect.swiftness": "Poció de velocitat persistent",
  "item.minecraft.lingering_potion.effect.thick": "Poció densa persistent",
  "item.minecraft.lingering_potion.effect.turtle_master": "Poció persistent del Mestre tortuga",
  "item.minecraft.lingering_potion.effect.water": "Ampolla d'aigua persistent",
  "item.minecraft.lingering_potion.effect.water_breathing": "Poció de respiració aquàtica persistent",
  "item.minecraft.lingering_potion.effect.weakness": "Poció debilitant persistent",
  "item.minecraft.lingering_potion.effect.weaving": "Poció de teixidura persistent",
  "item.minecraft.lingering_potion.effect.wind_charged": "Poció de vent carregat persistent",
  "item.minecraft.llama_spawn_egg": "Generar llama",
  "item.minecraft.lodestone_compass": "Brúixola guia",
  "item.minecraft.mace": "Maça",
  "item.minecraft.magenta_bundle": "Sarró magenta",
  "item.minecraft.magenta_dye": "Tint magenta",
  "item.minecraft.magenta_harness": "Arnès Magenta",
  "item.minecraft.magma_cream": "Crema de magma",
  "item.minecraft.magma_cube_spawn_egg": "Generar cub de magma",
  "item.minecraft.mangrove_boat": "Barca de mangle",
  "item.minecraft.mangrove_chest_boat": "Barca de mangle amb cofre",
  "item.minecraft.map": "Mapa en blanc",
  "item.minecraft.melon_seeds": "Llavors de síndria",
  "item.minecraft.melon_slice": "Tallada de síndria",
  "item.minecraft.milk_bucket": "Galleda amb llet",
  "item.minecraft.minecart": "Vagoneta",
  "item.minecraft.miner_pottery_shard": "Fragment de ceràmica de miner",
  "item.minecraft.miner_pottery_sherd": "Fragment de ceràmica de miner",
  "item.minecraft.mojang_banner_pattern": "Patró de Mojang",
  "item.minecraft.mojang_banner_pattern.desc": "Estampat de Mojang",
  "item.minecraft.mojang_banner_pattern.new": "Estampat de Mojang",
  "item.minecraft.mooshroom_spawn_egg": "Generar mooshroom",
  "item.minecraft.mourner_pottery_shard": "Fragment de ceràmica de Vigilant",
  "item.minecraft.mourner_pottery_sherd": "Fragment de ceràmica de Vigilant",
  "item.minecraft.mule_spawn_egg": "Generar mula",
  "item.minecraft.mushroom_stew": "Estofat de bolets",
  "item.minecraft.music_disc_11": "Disc de música",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Disc de música",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Disc de música",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Disc de música",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Disc de música",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Disc de música",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Disc de música",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Disc de música",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Music Box)",
  "item.minecraft.music_disc_far": "Disc de música",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Disc de música",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Disc de música",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Disc de música",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Disc de música",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Disc de música",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Disc de música",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Disc de música",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "Disc de música",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Disc de música",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Disc de música",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Disc de música",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Disc de música",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Carn d'ovella crua",
  "item.minecraft.name_tag": "Etiqueta de nom",
  "item.minecraft.nautilus_shell": "Closca de nàutil",
  "item.minecraft.nautilus_spawn_egg": "Generar Nautilus",
  "item.minecraft.nether_brick": "Maó del Nether",
  "item.minecraft.nether_star": "Estrella del Nether",
  "item.minecraft.nether_wart": "Berruga del Nether",
  "item.minecraft.netherite_axe": "Destral de netherita",
  "item.minecraft.netherite_boots": "Botes de netherita",
  "item.minecraft.netherite_chestplate": "Cuirassa de netherita",
  "item.minecraft.netherite_helmet": "Casc de netherita",
  "item.minecraft.netherite_hoe": "Aixada de netherita",
  "item.minecraft.netherite_horse_armor": "Armadura de cavall de netherita",
  "item.minecraft.netherite_ingot": "Lingot de netherita",
  "item.minecraft.netherite_leggings": "Malles de netherita",
  "item.minecraft.netherite_nautilus_armor": "Armadura de Nautilus de netherita",
  "item.minecraft.netherite_pickaxe": "Pic de netherita",
  "item.minecraft.netherite_scrap": "Ferralla de netherita",
  "item.minecraft.netherite_shovel": "Pala de netherita",
  "item.minecraft.netherite_spear": "Llança de netherita",
  "item.minecraft.netherite_sword": "Espasa de netherita",
  "item.minecraft.netherite_upgrade_smithing_template": "Patró de ferreria",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Millora de netherita",
  "item.minecraft.oak_boat": "Barca de pomer",
  "item.minecraft.oak_chest_boat": "Barca de pomer amb cofre",
  "item.minecraft.ocelot_spawn_egg": "Generar ocelot",
  "item.minecraft.ominous_bottle": "Ampolla ominosa",
  "item.minecraft.ominous_trial_key": "Clau de reptes ominós",
  "item.minecraft.orange_bundle": "Sarró taronja",
  "item.minecraft.orange_dye": "Tint taronja",
  "item.minecraft.orange_harness": "Arnès Cian",
  "item.minecraft.painting": "Quadre",
  "item.minecraft.pale_oak_boat": "Barca de roure pàl·lid",
  "item.minecraft.pale_oak_chest_boat": "Barca de roure pàl·lid amb cofre",
  "item.minecraft.panda_spawn_egg": "Generar panda",
  "item.minecraft.paper": "Paper",
  "item.minecraft.parched_spawn_egg": "Ou de generació Assedegat",
  "item.minecraft.parrot_spawn_egg": "Generar lloro",
  "item.minecraft.phantom_membrane": "Membrana fantasmal",
  "item.minecraft.phantom_spawn_egg": "Generar fantasma",
  "item.minecraft.pig_spawn_egg": "Generar porc",
  "item.minecraft.piglin_banner_pattern": "Patró de piglin",
  "item.minecraft.piglin_banner_pattern.desc": "Morro",
  "item.minecraft.piglin_banner_pattern.new": "Estampat de musell",
  "item.minecraft.piglin_brute_spawn_egg": "Generar piglin ferotge",
  "item.minecraft.piglin_spawn_egg": "Generar piglin",
  "item.minecraft.pillager_spawn_egg": "Generar saquejador",
  "item.minecraft.pink_bundle": "Sarró rosa",
  "item.minecraft.pink_dye": "Tint rosa",
  "item.minecraft.pink_harness": "Arnès Rosa",
  "item.minecraft.pitcher_plant": "Planta gerro",
  "item.minecraft.pitcher_pod": "Beina de planta gerro",
  "item.minecraft.plenty_pottery_shard": "Fragment de ceràmica de cofre",
  "item.minecraft.plenty_pottery_sherd": "Fragment de ceràmica de cofre",
  "item.minecraft.poisonous_potato": "Patata verinosa",
  "item.minecraft.polar_bear_spawn_egg": "Generar ós polar",
  "item.minecraft.popped_chorus_fruit": "Fruita de tornada cuita",
  "item.minecraft.porkchop": "Carn de porc crua",
  "item.minecraft.potato": "Patata",
  "item.minecraft.potion": "Poció",
  "item.minecraft.potion.effect.awkward": "Poció estranya",
  "item.minecraft.potion.effect.empty": "Poció impossible d'elaborar",
  "item.minecraft.potion.effect.fire_resistance": "Poció de resistència ígnia",
  "item.minecraft.potion.effect.harming": "Poció danyosa",
  "item.minecraft.potion.effect.healing": "Poció de curació",
  "item.minecraft.potion.effect.infested": "Poció d'infestació",
  "item.minecraft.potion.effect.invisibility": "Poció d'invisibilitat",
  "item.minecraft.potion.effect.leaping": "Poció de salt",
  "item.minecraft.potion.effect.levitation": "Poció de levitació",
  "item.minecraft.potion.effect.luck": "Poció sortosa",
  "item.minecraft.potion.effect.mundane": "Poció mundana",
  "item.minecraft.potion.effect.night_vision": "Poció de visió nocturna",
  "item.minecraft.potion.effect.oozing": "Poció de supura",
  "item.minecraft.potion.effect.poison": "Poció verinosa",
  "item.minecraft.potion.effect.regeneration": "Poció de regeneració",
  "item.minecraft.potion.effect.slow_falling": "Poció de caiguda lenta",
  "item.minecraft.potion.effect.slowness": "Poció alentidora",
  "item.minecraft.potion.effect.strength": "Poció de força",
  "item.minecraft.potion.effect.swiftness": "Poció de velocitat",
  "item.minecraft.potion.effect.thick": "Poció densa",
  "item.minecraft.potion.effect.turtle_master": "Poció del Mestre tortuga",
  "item.minecraft.potion.effect.water": "Ampolla d'aigua",
  "item.minecraft.potion.effect.water_breathing": "Poció de respiració aquàtica",
  "item.minecraft.potion.effect.weakness": "Poció debilitant",
  "item.minecraft.potion.effect.weaving": "Poció de teixidura",
  "item.minecraft.potion.effect.wind_charged": "Poció de vent carregat",
  "item.minecraft.pottery_shard_archer": "Fragment de ceràmica d'arquer",
  "item.minecraft.pottery_shard_arms_up": "Fragment de ceràmica de ninot",
  "item.minecraft.pottery_shard_prize": "Fragment de ceràmica de joia",
  "item.minecraft.pottery_shard_skull": "Fragment de ceràmica de calavera",
  "item.minecraft.powder_snow_bucket": "Galleda de neu pols",
  "item.minecraft.prismarine_crystals": "Cristalls de prismarina",
  "item.minecraft.prismarine_shard": "Fragment de prismarina",
  "item.minecraft.prize_pottery_shard": "Fragment de ceràmica de joia",
  "item.minecraft.prize_pottery_sherd": "Fragment de ceràmica de joia",
  "item.minecraft.pufferfish": "Peix globus",
  "item.minecraft.pufferfish_bucket": "Galleda amb peix globus",
  "item.minecraft.pufferfish_spawn_egg": "Generar peix globus",
  "item.minecraft.pumpkin_pie": "Pastís de carbassa",
  "item.minecraft.pumpkin_seeds": "Llavors de carbassa",
  "item.minecraft.purple_bundle": "Sarró lila",
  "item.minecraft.purple_dye": "Tint lila",
  "item.minecraft.purple_harness": "Arnès Violeta",
  "item.minecraft.quartz": "Quars del Nether",
  "item.minecraft.rabbit": "Carn de conill crua",
  "item.minecraft.rabbit_foot": "Pota de conill",
  "item.minecraft.rabbit_hide": "Pell de conill",
  "item.minecraft.rabbit_spawn_egg": "Generar conill",
  "item.minecraft.rabbit_stew": "Estofat de conill",
  "item.minecraft.raiser_armor_trim_smithing_template": "Patró de ferreria",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Disseny d'armadura d'elevació",
  "item.minecraft.ravager_spawn_egg": "Generar devastador",
  "item.minecraft.raw_copper": "Coure en brut",
  "item.minecraft.raw_gold": "Or en brut",
  "item.minecraft.raw_iron": "Ferro en brut",
  "item.minecraft.recovery_compass": "Brúixola de retorn",
  "item.minecraft.red_bundle": "Sarró vermell",
  "item.minecraft.red_dye": "Tint vermell",
  "item.minecraft.red_harness": "Arnès Vermell",
  "item.minecraft.redstone": "Pols de redstone",
  "item.minecraft.resin_brick": "Maons de resina",
  "item.minecraft.resin_clump": "Grumoll de resina",
  "item.minecraft.rib_armor_trim_smithing_template": "Patró de ferreria",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Patró d'armadura de costella",
  "item.minecraft.rotten_flesh": "Carn podrida",
  "item.minecraft.saddle": "Sella de muntar",
  "item.minecraft.salmon": "Salmó cru",
  "item.minecraft.salmon_bucket": "Galleda amb salmó",
  "item.minecraft.salmon_spawn_egg": "Generar salmó",
  "item.minecraft.scrape_pottery_sherd": "Fragment de ceràmica de destral",
  "item.minecraft.scute": "Escata",
  "item.minecraft.sentry_armor_trim_smithing_template": "Patró de ferreria",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Patró d'armadura de sentinella",
  "item.minecraft.shaper_armor_trim_smithing_template": "Patró de ferreria",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Patró d'armadura de modelador",
  "item.minecraft.sheaf_pottery_shard": "Fragment de ceràmica de palla",
  "item.minecraft.sheaf_pottery_sherd": "Fragment de ceràmica de blat",
  "item.minecraft.shears": "Tisores d'esquilar",
  "item.minecraft.sheep_spawn_egg": "Generar ovella",
  "item.minecraft.shelter_pottery_shard": "Fragment de ceràmica de refugi",
  "item.minecraft.shelter_pottery_sherd": "Fragment de ceràmica de refugi",
  "item.minecraft.shield": "Escut",
  "item.minecraft.shield.black": "Escut negre",
  "item.minecraft.shield.blue": "Escut blau",
  "item.minecraft.shield.brown": "Escut marró",
  "item.minecraft.shield.cyan": "Escut cian",
  "item.minecraft.shield.gray": "Escut gris",
  "item.minecraft.shield.green": "Escut verd",
  "item.minecraft.shield.light_blue": "Escut blau cel",
  "item.minecraft.shield.light_gray": "Escut gris clar",
  "item.minecraft.shield.lime": "Escut llima",
  "item.minecraft.shield.magenta": "Escut magenta",
  "item.minecraft.shield.orange": "Escut taronja",
  "item.minecraft.shield.pink": "Escut rosa",
  "item.minecraft.shield.purple": "Escut lila",
  "item.minecraft.shield.red": "Escut vermell",
  "item.minecraft.shield.white": "Escut blanc",
  "item.minecraft.shield.yellow": "Escut groc",
  "item.minecraft.shulker_shell": "Closca de shulker",
  "item.minecraft.shulker_spawn_egg": "Generar shulker",
  "item.minecraft.sign": "Cartell",
  "item.minecraft.silence_armor_trim_smithing_template": "Patró de ferreria",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Disseny d'armadura de silenci",
  "item.minecraft.silverfish_spawn_egg": "Generar peixet de plata",
  "item.minecraft.skeleton_horse_spawn_egg": "Generar cavall esquelètic",
  "item.minecraft.skeleton_spawn_egg": "Generar esquelet",
  "item.minecraft.skull_banner_pattern": "Patró de calavera",
  "item.minecraft.skull_banner_pattern.desc": "Estampat de calavera",
  "item.minecraft.skull_banner_pattern.new": "Estampat de calavera",
  "item.minecraft.skull_pottery_shard": "Fragment de ceràmica de calavera",
  "item.minecraft.skull_pottery_sherd": "Fragment de ceràmica de calavera",
  "item.minecraft.slime_ball": "Bola de llim",
  "item.minecraft.slime_spawn_egg": "Generar llim",
  "item.minecraft.smithing_template": "Patró de ferreria",
  "item.minecraft.smithing_template.applies_to": "S'aplica a:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Afegeix un lingot o un cristall",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armadura",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Afegeix una peça d'armadura",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Lingots i cristalls",
  "item.minecraft.smithing_template.ingredients": "Ingredients:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Afegeix un lingot de netherita",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Armament de diamant",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Afegeix una armadura, arma o eina de diamant",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Lingot de netherita",
  "item.minecraft.smithing_template.upgrade": "Millorar: ",
  "item.minecraft.sniffer_spawn_egg": "Generar ensumador",
  "item.minecraft.snort_pottery_shard": "Fragment de ceràmica d'ensumador",
  "item.minecraft.snort_pottery_sherd": "Fragment de ceràmica d'ensumador",
  "item.minecraft.snout_armor_trim_smithing_template": "Patró de ferreria",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Disseny d'armadura de musell",
  "item.minecraft.snow_golem_spawn_egg": "Generar gòlem de neu",
  "item.minecraft.snowball": "Bola de neu",
  "item.minecraft.spectral_arrow": "Fletxa fantasmal",
  "item.minecraft.spider_eye": "Ull d'aranya",
  "item.minecraft.spider_spawn_egg": "Generar aranya",
  "item.minecraft.spire_armor_trim_smithing_template": "Patró de ferreria",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Disseny d'armadura d'agulles",
  "item.minecraft.splash_potion": "Poció llancívola",
  "item.minecraft.splash_potion.effect.awkward": "Poció estranya llancívola",
  "item.minecraft.splash_potion.effect.empty": "Poció llancívola impossible d'elaborar",
  "item.minecraft.splash_potion.effect.fire_resistance": "Poció de resistència ígnia llancívola",
  "item.minecraft.splash_potion.effect.harming": "Poció danyosa llancívola",
  "item.minecraft.splash_potion.effect.healing": "Poció de curació llancívola",
  "item.minecraft.splash_potion.effect.infested": "Poció d'infestació llancívola",
  "item.minecraft.splash_potion.effect.invisibility": "Poció d'invisibilitat llancívola",
  "item.minecraft.splash_potion.effect.leaping": "Poció de salt llancívola",
  "item.minecraft.splash_potion.effect.levitation": "Poció de levitació llancívola",
  "item.minecraft.splash_potion.effect.luck": "Poció sortosa llancívola",
  "item.minecraft.splash_potion.effect.mundane": "Poció mundana llancívola",
  "item.minecraft.splash_potion.effect.night_vision": "Poció de visió nocturna llancívola",
  "item.minecraft.splash_potion.effect.oozing": "Poció de supura llancívola",
  "item.minecraft.splash_potion.effect.poison": "Poció verinosa llancívola",
  "item.minecraft.splash_potion.effect.regeneration": "Poció de regeneració llancívola",
  "item.minecraft.splash_potion.effect.slow_falling": "Poció llancívola de caiguda lenta",
  "item.minecraft.splash_potion.effect.slowness": "Poció alentidora llancívola",
  "item.minecraft.splash_potion.effect.strength": "Poció de força llancívola",
  "item.minecraft.splash_potion.effect.swiftness": "Poció de velocitat llancívola",
  "item.minecraft.splash_potion.effect.thick": "Poció densa llancívola",
  "item.minecraft.splash_potion.effect.turtle_master": "Poció llancívola del Mestre tortuga",
  "item.minecraft.splash_potion.effect.water": "Ampolla d'aigua llancívola",
  "item.minecraft.splash_potion.effect.water_breathing": "Poció de respiració aquàtica llancívola",
  "item.minecraft.splash_potion.effect.weakness": "Poció debilitant llancívola",
  "item.minecraft.splash_potion.effect.weaving": "Poció de teixidura llancívola",
  "item.minecraft.splash_potion.effect.wind_charged": "Poció de carregada de vent llancívola",
  "item.minecraft.spruce_boat": "Barca de pi",
  "item.minecraft.spruce_chest_boat": "Barca de pi amb cofre",
  "item.minecraft.spyglass": "Ullera de llarga vista",
  "item.minecraft.squid_spawn_egg": "Generar calamar",
  "item.minecraft.stick": "Pal",
  "item.minecraft.stone_axe": "Destral de pedra",
  "item.minecraft.stone_hoe": "Aixada de pedra",
  "item.minecraft.stone_pickaxe": "Pic de pedra",
  "item.minecraft.stone_shovel": "Pala de pedra",
  "item.minecraft.stone_spear": "Llança de pedra",
  "item.minecraft.stone_sword": "Espasa de pedra",
  "item.minecraft.stray_spawn_egg": "Generar esquelet extraviat",
  "item.minecraft.strider_spawn_egg": "Generar caminant",
  "item.minecraft.string": "Fil",
  "item.minecraft.sugar": "Sucre",
  "item.minecraft.suspicious_stew": "Estofat sospitós",
  "item.minecraft.sweet_berries": "Baies dolces",
  "item.minecraft.tadpole_bucket": "Galleda amb capgròs",
  "item.minecraft.tadpole_spawn_egg": "Generar capgròs",
  "item.minecraft.tide_armor_trim_smithing_template": "Patró de ferreria",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Disseny d'armadura de la marea",
  "item.minecraft.tipped_arrow": "Fletxa amb efecte",
  "item.minecraft.tipped_arrow.effect.awkward": "Fletxa amb efecte",
  "item.minecraft.tipped_arrow.effect.empty": "Fletxa amb efecte impossible d'elaborar",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Fletxa de resistència ígnia",
  "item.minecraft.tipped_arrow.effect.harming": "Fletxa de dany augmentat",
  "item.minecraft.tipped_arrow.effect.healing": "Fletxa curativa",
  "item.minecraft.tipped_arrow.effect.infested": "Fletxa d'infestació",
  "item.minecraft.tipped_arrow.effect.invisibility": "Fletxa d'invisibilitat",
  "item.minecraft.tipped_arrow.effect.leaping": "Fletxa de salt",
  "item.minecraft.tipped_arrow.effect.levitation": "Fletxa de levitació",
  "item.minecraft.tipped_arrow.effect.luck": "Fletxa sortosa",
  "item.minecraft.tipped_arrow.effect.mundane": "Fletxa amb efecte",
  "item.minecraft.tipped_arrow.effect.night_vision": "Fletxa de visió nocturna",
  "item.minecraft.tipped_arrow.effect.oozing": "Fletxa de supura",
  "item.minecraft.tipped_arrow.effect.poison": "Fletxa de verí",
  "item.minecraft.tipped_arrow.effect.regeneration": "Fletxa de regeneració",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Fletxa de caiguda lenta",
  "item.minecraft.tipped_arrow.effect.slowness": "Fletxa alentidora",
  "item.minecraft.tipped_arrow.effect.strength": "Fletxa de força",
  "item.minecraft.tipped_arrow.effect.swiftness": "Fletxa de velocitat",
  "item.minecraft.tipped_arrow.effect.thick": "Fletxa amb efecte",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Fletxa del Mestre tortuga",
  "item.minecraft.tipped_arrow.effect.water": "Fletxa esquitxadora",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Fletxa de respiració aquàtica",
  "item.minecraft.tipped_arrow.effect.weakness": "Fletxa debilitant",
  "item.minecraft.tipped_arrow.effect.weaving": "Fletxa de teixidura",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Fletxa de vent carregat",
  "item.minecraft.tnt_minecart": "Vagoneta amb dinamita",
  "item.minecraft.torchflower_seeds": "Llavors de florxa",
  "item.minecraft.totem_of_undying": "Tòtem de l'immortalitat",
  "item.minecraft.trader_llama_spawn_egg": "Generar llama ambulant",
  "item.minecraft.trial_key": "Clau de reptes",
  "item.minecraft.trident": "Trident",
  "item.minecraft.tropical_fish": "Peix tropical",
  "item.minecraft.tropical_fish_bucket": "Galleda amb peix tropical",
  "item.minecraft.tropical_fish_spawn_egg": "Generar peix tropical",
  "item.minecraft.turtle_helmet": "Closca de tortuga",
  "item.minecraft.turtle_scute": "Escata de tortuga",
  "item.minecraft.turtle_spawn_egg": "Generar tortuga",
  "item.minecraft.vex_armor_trim_smithing_template": "Patró de ferreria",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Disseny d'armadura d'esperit",
  "item.minecraft.vex_spawn_egg": "Generar esperit",
  "item.minecraft.villager_spawn_egg": "Generar vilatà",
  "item.minecraft.vindicator_spawn_egg": "Generar vindicador",
  "item.minecraft.wandering_trader_spawn_egg": "Generar comerciant",
  "item.minecraft.ward_armor_trim_smithing_template": "Patró de ferreria",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Disseny d'armadura de vigilant",
  "item.minecraft.warden_spawn_egg": "Generar vigilant",
  "item.minecraft.warped_fungus_on_a_stick": "Canya amb fong guerxo",
  "item.minecraft.water_bucket": "Galleda d'aigua",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Patró de ferreria",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Disseny d'armadura de cerca camins",
  "item.minecraft.wheat": "Blat",
  "item.minecraft.wheat_seeds": "Llavors de blat",
  "item.minecraft.white_bundle": "Sarró blanc",
  "item.minecraft.white_dye": "Tint blanc",
  "item.minecraft.white_harness": "Arnès Blanc",
  "item.minecraft.wild_armor_trim_smithing_template": "Patró de ferreria",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Disseny d'armadura salvatge",
  "item.minecraft.wind_charge": "Càrrega Ventosa",
  "item.minecraft.witch_spawn_egg": "Generar bruixa",
  "item.minecraft.wither_skeleton_spawn_egg": "Generar esquelet wither",
  "item.minecraft.wither_spawn_egg": "Generar wither",
  "item.minecraft.wolf_armor": "Armadura de llop",
  "item.minecraft.wolf_spawn_egg": "Generar llop",
  "item.minecraft.wooden_axe": "Destral de fusta",
  "item.minecraft.wooden_hoe": "Aixada de fusta",
  "item.minecraft.wooden_pickaxe": "Pic de fusta",
  "item.minecraft.wooden_shovel": "Pala de fusta",
  "item.minecraft.wooden_spear": "Llança de fusta",
  "item.minecraft.wooden_sword": "Espasa de fusta",
  "item.minecraft.writable_book": "Llibre i tinter",
  "item.minecraft.written_book": "Llibre escrit",
  "item.minecraft.yellow_bundle": "Sarró groc",
  "item.minecraft.yellow_dye": "Tint groc",
  "item.minecraft.yellow_harness": "Arnès Groc",
  "item.minecraft.zoglin_spawn_egg": "Generar zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Generar cavall zombi",
  "item.minecraft.zombie_nautilus_spawn_egg": "Generar del Nautilus",
  "item.minecraft.zombie_spawn_egg": "Generar zombi",
  "item.minecraft.zombie_villager_spawn_egg": "Generar vilatà zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "Generar piglin zombificat"
}
export const ca_es = items; 
